// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$resolve(url) {  url = importMap[url] || url;  return new URL(distDir + url, import.meta.url).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"b94kx":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "lkrLs": "bus-tiny.3fbef928.png",
    "1mZqJ": "stop.43e1f1bb.png",
    "eVywM": "stop-end.6bca41b1.png",
    "aR9Wp": "mrt-station.07aa1631.png",
    "iFswf": "lrt-station.676bf897.png",
    "kJ0PH": "open-new-window.f691ae9d.svg",
    "asY4P": "open-new-window-blue.f7c7b2f5.svg",
    "bEn0N": "passing-routes-blue.073957f1.svg",
    "kOgQG": "icon.77e9e1f9.svg",
    "3cARN": "service-worker.js"
});

},{}],"iC1JR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _i18N = require("./i18n");
var _errorTracking = require("./error-tracking");
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _maplibreGl = require("maplibre-gl");
var _maplibreGlDefault = parcelHelpers.interopDefault(_maplibreGl);
var _polyline = require("@mapbox/polyline");
var _fuseJs = require("fuse.js");
var _fuseJsDefault = parcelHelpers.interopDefault(_fuseJs);
var _justIntersect = require("just-intersect");
var _justIntersectDefault = parcelHelpers.interopDefault(_justIntersect);
var _cheapRuler = require("cheap-ruler");
var _cheapRulerDefault = parcelHelpers.interopDefault(_cheapRuler);
var _mapboxGlLanguage = require("@mapbox/mapbox-gl-language");
var _mapboxGlLanguageDefault = parcelHelpers.interopDefault(_mapboxGlLanguage);
var _reactI18Next = require("react-i18next");
var _pmtiles = require("pmtiles");
var _mapStyle = require("./map-style");
var _specialID = require("./utils/specialID");
var _bus = require("./utils/bus");
var _fetchCache = require("./utils/fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
var _getRoute = require("./utils/getRoute");
var _getRouteDefault = parcelHelpers.interopDefault(_getRoute);
var _getDistance = require("./utils/getDistance");
var _getDistanceDefault = parcelHelpers.interopDefault(_getDistance);
var _getWalkingMinutes = require("./utils/getWalkingMinutes");
var _getWalkingMinutesDefault = parcelHelpers.interopDefault(_getWalkingMinutes);
var _usePrevious = require("./utils/usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _ad = require("./ad");
var _adDefault = parcelHelpers.interopDefault(_ad);
var _about = require("./components/About");
var _aboutDefault = parcelHelpers.interopDefault(_about);
var _busServicesArrival = require("./components/BusServicesArrival");
var _busServicesArrivalDefault = parcelHelpers.interopDefault(_busServicesArrival);
var _geolocateControl = require("./components/GeolocateControl");
var _geolocateControlDefault = parcelHelpers.interopDefault(_geolocateControl);
var _betweenRoutes = require("./components/BetweenRoutes");
var _betweenRoutesDefault = parcelHelpers.interopDefault(_betweenRoutes);
var _scrollableContainer = require("./components/ScrollableContainer");
var _scrollableContainerDefault = parcelHelpers.interopDefault(_scrollableContainer);
var _stopsListJsx = require("./components/StopsList.jsx");
var _stopsListJsxDefault = parcelHelpers.interopDefault(_stopsListJsx);
var _stopPng = require("./images/stop.png");
var _stopPngDefault = parcelHelpers.interopDefault(_stopPng);
var _stopEndPng = require("./images/stop-end.png");
var _stopEndPngDefault = parcelHelpers.interopDefault(_stopEndPng);
var _mrtStationPng = require("./images/mrt-station.png");
var _mrtStationPngDefault = parcelHelpers.interopDefault(_mrtStationPng);
var _lrtStationPng = require("./images/lrt-station.png");
var _lrtStationPngDefault = parcelHelpers.interopDefault(_lrtStationPng);
var _openNewWindowSvg = require("./images/open-new-window.svg");
var _openNewWindowSvgDefault = parcelHelpers.interopDefault(_openNewWindowSvg);
var _openNewWindowBlueSvg = require("./images/open-new-window-blue.svg");
var _openNewWindowBlueSvgDefault = parcelHelpers.interopDefault(_openNewWindowBlueSvg);
var _passingRoutesBlueSvg = require("./images/passing-routes-blue.svg");
var _passingRoutesBlueSvgDefault = parcelHelpers.interopDefault(_passingRoutesBlueSvg);
var _iconSvg = require("../icons/icon.svg");
var _iconSvgDefault = parcelHelpers.interopDefault(_iconSvg);
var _busTinyPng = require("./images/bus-tiny.png");
var _busTinyPngDefault = parcelHelpers.interopDefault(_busTinyPng);
const dataPath = 'https://data.busrouter.sg/v1/';
const routesJSONPath = dataPath + 'routes.min.json';
const stopsJSONPath = dataPath + 'stops.min.json';
const servicesJSONPath = dataPath + 'services.min.json';
const $map = document.getElementById('map');
const STORE = {};
const BREAKPOINT = ()=>window.innerWidth > 640;
const supportsHover = window.matchMedia && matchMedia('(any-hover: hover)').matches;
const supportsTouch = window.matchMedia && matchMedia('(any-pointer: coarse)').matches || 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
const ruler = new (0, _cheapRulerDefault.default)(1.3);
const $logo = document.getElementById('logo');
let rafST;
const rafScrollTop = ()=>{
    window.scrollTo(0, 0);
    rafST = requestAnimationFrame(rafScrollTop);
};
const $tooltip = document.getElementById('tooltip');
function showStopTooltip(data) {
    $tooltip.innerHTML = `<span class="stop-tag">${data.number}</span> ${data.name}`;
    $tooltip.classList.add('show');
    const { x, y: top } = data;
    const left = Math.max(5 + $map.offsetLeft, Math.min(window.innerWidth - $tooltip.offsetWidth - 5, x + $map.offsetLeft - 5));
    $tooltip.style.transform = `translate(${left}px, ${top}px)`;
}
function hideStopTooltip() {
    $tooltip.classList.remove('show');
}
window.requestIdleCallback = window.requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const lowerLat = 1.2, upperLat = 1.48, lowerLong = 103.59, upperLong = 104.05;
const CACHE_TIME = 1440; // 1 day
let map;
let servicesDataArr = [];
let stopsDataArr = [];
let servicesData;
let stopsData = {};
let routesData;
let fuseServices;
let fuseStops;
const App = ()=>{
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    const [route, setRoute] = (0, _hooks.useState)((0, _getRouteDefault.default)());
    const prevRoute = (0, _usePreviousDefault.default)(route);
    const [routeLoading, setRouteLoading] = (0, _hooks.useState)(true);
    const [services, setServices] = (0, _hooks.useState)([]);
    const [stops, setStops] = (0, _hooks.useState)([]);
    const [searching, setSearching] = (0, _hooks.useState)(false);
    const [expandSearch, setExpandSearch] = (0, _hooks.useState)(false);
    const [expandedSearchOnce, setExpandedSearchOnce] = (0, _hooks.useState)(false);
    const [shrinkSearch, setShrinkSearch] = (0, _hooks.useState)(false);
    const [stopPopoverData, setStopPopoverData] = (0, _hooks.useState)(null);
    const [showStopPopover, setShowStopPopover] = (0, _hooks.useState)(false);
    const [showServicePopover, setShowServicePopover] = (0, _hooks.useState)(false);
    const [showArrivalsPopover, setShowArrivalsPopover] = (0, _hooks.useState)(false);
    const [intersectStops, setIntersectStops] = (0, _hooks.useState)(0);
    const [showAd, setShowAd] = (0, _hooks.useState)(false);
    const [routeServices, setRouteServices] = (0, _hooks.useState)([]);
    const [showBetweenPopover, setShowBetweenPopover] = (0, _hooks.useState)(false);
    const [betweenStartStop, setBetweenStartStop] = (0, _hooks.useState)(null);
    const [betweenEndStop, setBetweenEndStop] = (0, _hooks.useState)(null);
    const prevStopNumber = (0, _hooks.useRef)(null);
    const servicesList = (0, _hooks.useRef)(null);
    const searchField = (0, _hooks.useRef)(null);
    const searchPopover = (0, _hooks.useRef)(null);
    const stopPopover = (0, _hooks.useRef)(null);
    const floatPill = (0, _hooks.useRef)(null);
    const betweenPopover = (0, _hooks.useRef)(null);
    const servicePopover = (0, _hooks.useRef)(null);
    let previewRAF = (0, _hooks.useRef)(null).current;
    let labelLayerId;
    const largerScreen = window.matchMedia('(min-width: 1200px) and (min-height: 600px) and (orientation: landscape)').matches;
    const handleKeys = (e)=>{
        switch(e.key.toLowerCase()){
            case 'enter':
                {
                    const link = servicesList.current?.querySelector('li a[href^="#"]');
                    if (link) {
                        searchField.current?.blur();
                        link.click();
                    }
                    break;
                }
        }
    };
    const handleSearchFocus = (e)=>{
        setExpandSearch(true);
        setExpandedSearchOnce(true);
        // $map.classList.add('fade-out');
        rafScrollTop();
        searchPopover.current?.addEventListener('transitionend', (e)=>{
            cancelAnimationFrame(rafST);
        });
    };
    const handleSearch = (e)=>{
        const { value } = e && e.target || searchField;
        if (value) {
            const services = fuseServices.search(value);
            let stops = [];
            if (services.length < 20) stops = fuseStops.search(value);
            setServices(services.map((s)=>s.item));
            setStops(stops.map((s)=>s.item));
            setSearching(true);
            // Scroll to top, with hack for momentum scrolling
            // https://popmotion.io/blog/20170704-manually-set-scroll-while-ios-momentum-scroll-bounces/
            servicesList.current.style['-webkit-overflow-scrolling'] = 'auto';
            servicesList.current.scrollTop = 0;
            servicesList.current.style['-webkit-overflow-scrolling'] = null;
        } else {
            setServices(servicesDataArr);
            setStops([]);
            setSearching(false);
        }
    };
    const handleSearchClose = ()=>{
        setExpandSearch(false);
        $map.classList.remove('fade-out');
        resetSearch();
    };
    const resetSearch = ()=>{
        searchField.current?.blur();
        searchField.current.value = '';
        setSearching(false);
        setServices(servicesDataArr);
        setStops([]);
    };
    const handleServicesScroll = ()=>{
        if (expandSearch || expandedSearchOnce) return;
        setExpandSearch(true);
        setExpandedSearchOnce(true);
    // $map.classList.add('fade-out');
    };
    const _showStopPopover = (number)=>{
        const { services, coordinates, name } = stopsData[number];
        const popoverHeight = stopPopover.current?.offsetHeight;
        const offset = BREAKPOINT() ? [
            0,
            0
        ] : [
            0,
            -popoverHeight / 2
        ];
        const zoom = map.getZoom();
        if (zoom < 17) map.flyTo({
            zoom: 17,
            center: coordinates,
            offset,
            animate: zoom >= 12
        });
        else map.easeTo({
            center: coordinates,
            offset
        });
        if (prevStopNumber.current) {
            map.setFeatureState({
                source: 'stops',
                id: (0, _specialID.encode)(prevStopNumber.current)
            }, {
                selected: false
            });
            map.setFeatureState({
                source: 'stops-highlight',
                id: (0, _specialID.encode)(prevStopNumber.current)
            }, {
                selected: false
            });
        }
        map.setFeatureState({
            source: 'stops',
            id: (0, _specialID.encode)(number)
        }, {
            selected: true
        });
        map.setFeatureState({
            source: 'stops-highlight',
            id: (0, _specialID.encode)(number)
        }, {
            selected: true
        });
        setShrinkSearch(true);
        prevStopNumber.current = number;
        setShowStopPopover(true);
        setStopPopoverData({
            number,
            name,
            services
        });
        requestAnimationFrame(()=>{
            if (popoverHeight === stopPopover.current?.offsetHeight) return;
            const offset = BREAKPOINT() ? [
                0,
                0
            ] : [
                0,
                -stopPopover.current?.offsetHeight / 2
            ];
            const zoom = map.getZoom();
            if (zoom < 17) map.flyTo({
                zoom: 17,
                center: coordinates,
                offset,
                animate: zoom >= 12
            });
            else map.easeTo({
                center: coordinates,
                offset
            });
        });
    };
    const hideStopPopover = (e)=>{
        const { page, subpage } = route;
        if (e && (page !== 'stop' || subpage === 'routes')) e.preventDefault();
        const number = stopPopoverData?.number || prevStopNumber.current;
        let stopToBeHighlighted;
        if (number) {
            map.setFeatureState({
                source: 'stops',
                id: (0, _specialID.encode)(number)
            }, {
                selected: false
            });
            map.setFeatureState({
                source: 'stops-highlight',
                id: (0, _specialID.encode)(number)
            }, {
                selected: false
            });
            if (stopPopover.current?.classList.contains('expand')) requestAnimationFrame(()=>{
                stopToBeHighlighted = servicePopover.current?.querySelector(`a[data-stop="${number}"]`);
                stopToBeHighlighted?.classList.add('flash');
                stopToBeHighlighted?.scrollIntoView({
                    behaviour: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
            });
        }
        setShowStopPopover(false);
        prevStopNumber.current = null;
        setTimeout(()=>{
            stopToBeHighlighted?.classList.remove('flash');
        }, 1000);
    };
    const navBackToStop = (e)=>{
        if (prevRoute?.page === 'stop') {
            e.preventDefault();
            history.back();
        }
    };
    const zoomToStop = (num)=>{
        const number = num || stopPopoverData?.number;
        const { coordinates } = stopsData[number];
        let offset = BREAKPOINT() ? [
            0,
            0
        ] : [
            0,
            -stopPopover.current.offsetHeight / 2
        ];
        if (showServicePopover) offset = BREAKPOINT() ? [
            -servicePopover.current.offsetWidth / 3,
            0
        ] : [
            0,
            -servicePopover.current.offsetHeight / 2
        ];
        const zoom = map.getZoom();
        if (zoom < 17) map.flyTo({
            zoom: 17,
            center: coordinates,
            offset
        });
        else map.easeTo({
            center: coordinates,
            offset
        });
    };
    const highlightRouteTag = (service)=>{
        const $servicesList = floatPill.current?.querySelector('.services-list');
        if (!$servicesList) return;
        if (service) {
            const otherServices = $servicesList.querySelectorAll('.service-tag');
            otherServices.forEach((el)=>{
                el.classList.remove('highlight');
                if (el.dataset.service.trim() === service.trim()) el.style.opacity = '';
                else el.style.opacity = 0.3;
            });
        } else $servicesList.querySelectorAll('.service-tag').forEach((el)=>el.style.opacity = '');
    };
    const clickRoute = (e, service)=>{
        const { target } = e;
        e.stopPropagation();
        if (target.classList.contains('highlight')) return;
        e.preventDefault();
        target.classList.add('highlight');
        highlightRoute(null, service, true);
    };
    const highlightRoute = (e, service, zoomIn)=>{
        if (e) e.target.classList.remove('highlight');
        const hoveredRouteID = (0, _specialID.encode)(service);
        map.setFeatureState({
            source: 'routes-path',
            id: hoveredRouteID
        }, {
            hover: true,
            fadein: false
        });
        STORE.routesPathServices?.forEach((service)=>{
            const id = (0, _specialID.encode)(service);
            if (hoveredRouteID === id) return;
            map.setFeatureState({
                source: 'routes-path',
                id
            }, {
                hover: false,
                fadein: true
            });
        });
        if (zoomIn) // Fit map to route bounds
        requestAnimationFrame(()=>{
            const { routes } = servicesData[service];
            const coordinates = routes[0].concat(routes[1] || []).map((stop)=>stopsData[stop].coordinates);
            const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
            coordinates.forEach((c)=>{
                bounds.extend(c);
            });
            map.fitBounds(bounds, {
                padding: largerScreen ? {
                    top: floatPill.current.offsetHeight / 2,
                    right: 80,
                    bottom: 80,
                    left: floatPill.current.offsetHeight / 2
                } : BREAKPOINT() ? {
                    top: 80,
                    right: Math.max(floatPill.current.offsetWidth / 2, 80),
                    bottom: 80 + floatPill.current.offsetHeight / 2,
                    left: Math.max(floatPill.current.offsetWidth / 2, 80)
                } : {
                    top: 80,
                    right: 80,
                    bottom: 80 + floatPill.current.offsetHeight,
                    // height of search bar + float pill
                    left: 80
                }
            });
        });
    };
    const unhighlightRoute = (e)=>{
        if (e && e.target?.classList.contains('service-tag')) e.target.classList.remove('highlight');
        STORE.routesPathServices?.forEach((service)=>{
            const id = (0, _specialID.encode)(service);
            map.setFeatureState({
                source: 'routes-path',
                id
            }, {
                fadein: false,
                hover: false
            });
        });
    };
    const openBusArrival = (e, showPopup = false)=>{
        if (e) e.preventDefault();
        const width = 360;
        const height = 480;
        const url = e.target.href;
        const stopNumber = url.match(/[^#]+$/)[0];
        showPopup = showPopup || window.innerWidth > width * 2 && window.innerHeight > height || window.innerWidth > window.innerHeight; // landscape is weird
        if (showPopup) {
            const top = ((screen.availHeight || screen.height) - height) / 2;
            const left = (screen.width - width) / 2;
            window.open(url, `busArrivals-${stopNumber}`, `width=${width},height=${height},menubar=0,toolbar=0,top=${top},left=${left}`);
        } else {
            setShowArrivalsPopover({
                webviewURL: url,
                number: stopNumber
            });
            $map.classList.add('fade-out');
        }
    };
    const closeBusArrival = (e)=>{
        if (e) e.preventDefault();
        setShowArrivalsPopover(false);
        $map.classList.remove('fade-out');
    };
    const _showBetweenPopover = (data)=>{
        setShrinkSearch(true);
        setShowBetweenPopover(data);
        // Auto-select first result
        setTimeout(()=>{
            const firstResult = betweenPopover.current.querySelector('.between-item');
            firstResult.click();
        }, 300);
    };
    const cannotPreviewRoute = ()=>{
        const { page, subpage, value } = route;
        return subpage === 'routes' || page === 'service' && value.split('~').length > 1;
    };
    const previewRoute = (service)=>{
        cancelAnimationFrame(previewRAF);
        if (cannotPreviewRoute()) return;
        previewRAF = requestAnimationFrame(()=>{
            const routes = routesData[service];
            const geometries = routes.map((route)=>(0, _polyline.toGeoJSON)(route));
            map.getSource('routes-path').setData({
                type: 'FeatureCollection',
                features: geometries.map((geometry)=>({
                        type: 'Feature',
                        id: (0, _specialID.encode)(service),
                        properties: {
                            service
                        },
                        geometry
                    }))
            });
        });
    };
    const unpreviewRoute = ()=>{
        cancelAnimationFrame(previewRAF);
        if (cannotPreviewRoute()) return;
        map.getSource('routes-path').setData({
            type: 'FeatureCollection',
            features: []
        });
    };
    const renderBetweenRoute = ({ e, startStop, endStop, result })=>{
        const { target } = e;
        target.parentElement.parentElement.querySelectorAll('.between-item').forEach((el)=>{
            if (el === target) target.classList.add('selected');
            else el.classList.remove('selected');
        });
        const stops = [
            {
                ...startStop,
                end: true
            },
            {
                ...endStop,
                end: true
            }
        ];
        if (result.startStop && result.startStop.number != startStop.number) stops.push({
            ...result.startStop,
            end: true
        });
        if (result.endStop && result.endStop.number != endStop.number) stops.push({
            ...result.endStop,
            end: true
        });
        if (result.stopsBetween.length) result.stopsBetween.forEach((number)=>stops.push(stopsData[number]));
        // Render stops
        map.getSource('stops-highlight').setData({
            type: 'FeatureCollection',
            features: stops.map((stop)=>({
                    type: 'Feature',
                    id: (0, _specialID.encode)(stop.number),
                    properties: {
                        name: stop.name,
                        number: stop.number,
                        type: stop.end ? 'end' : null,
                        left: stop.left
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: stop.coordinates
                    }
                }))
        });
        requestAnimationFrame(()=>{
            // Render routes
            const geometries = [];
            let [service, index] = result.startRoute.split('-');
            geometries.push((0, _polyline.toGeoJSON)(routesData[service][index]));
            if (result.endRoute) {
                let [service, index] = result.endRoute.split('-');
                geometries.push((0, _polyline.toGeoJSON)(routesData[service][index]));
            }
            if (result.startStop && result.startStop.number != startStop.number) geometries.push({
                type: 'LineString',
                coordinates: [
                    result.startStop.coordinates,
                    startStop.coordinates
                ]
            });
            if (result.endStop && result.endStop.number != endStop.number) geometries.push({
                type: 'LineString',
                coordinates: [
                    result.endStop.coordinates,
                    endStop.coordinates
                ]
            });
            map.getSource('routes-between').setData({
                type: 'FeatureCollection',
                features: geometries.map((geometry, i)=>({
                        type: 'Feature',
                        properties: {
                            type: i === 0 ? 'start' : i === 1 ? 'end' : 'walk'
                        },
                        geometry
                    }))
            });
            // Fit map to stops bounds
            const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
            stops.forEach((stop)=>{
                bounds.extend(stop.coordinates);
            });
            map.fitBounds(bounds, {
                padding: BREAKPOINT() ? {
                    top: 80,
                    right: betweenPopover.current.offsetWidth + 80,
                    bottom: 80,
                    left: 80
                } : {
                    top: 80,
                    right: 80,
                    bottom: betweenPopover.current.offsetHeight + 80,
                    left: 80
                }
            });
        });
    };
    const defaultURL = document.querySelector('meta[property="og:url"]').content;
    const defaultImg = document.querySelector('meta[property="og:image"]').content;
    const defaultHead = {
        title: [
            'app.title'
        ],
        url: defaultURL,
        desc: [
            'app.description'
        ],
        image: defaultImg
    };
    const [head, setHead] = (0, _hooks.useState)(defaultHead);
    (0, _hooks.useEffect)(()=>{
        let { title, url, desc, image } = head;
        document.title = document.querySelector('meta[property="og:title"]').content = Array.isArray(title) ? t(...title) : title;
        if (!/^https?/.test(url)) url = 'https://busrouter.sg/#' + url;
        document.querySelector('meta[property="og:url"]').content = url;
        document.querySelector('meta[name="description"]').content = document.querySelector('meta[property="og:description"]').content = Array.isArray(desc) ? t(...desc) : desc;
        document.querySelector('meta[property="og:image"]').content = image;
    }, [
        head
    ]);
    (0, _hooks.useEffect)(()=>{
        i18n.on('languageChanged', ()=>{
            setHead({
                ...head
            });
        });
    }, []);
    const renderRoute = ()=>{
        const route = (0, _getRouteDefault.default)();
        // Reset everything
        $map.classList.remove('fade-out');
        setShowStopPopover(false);
        setShowServicePopover(false);
        setShowBetweenPopover(false);
        [
            'stops-highlight',
            'routes',
            'routes-path',
            'routes-between',
            'buses-service'
        ].forEach((source)=>{
            map.getSource(source)?.setData({
                type: 'FeatureCollection',
                features: []
            });
        });
        if (prevStopNumber.current) hideStopPopover();
        switch(route.page){
            case 'service':
                {
                    const servicesValue = route.value;
                    const services = servicesValue.split('~').filter((s)=>servicesData[s]);
                    if (!services.length) return; // No value or none of the service codes are valid
                    // Reset
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    resetSearch();
                    // Hide all stops
                    map.setLayoutProperty('stops', 'visibility', 'none');
                    map.setLayoutProperty('stops-icon', 'visibility', 'none');
                    setRouteServices(services);
                    if (services.length === 1) {
                        const service = services[0];
                        const { name, routes } = servicesData[service];
                        setHead({
                            title: [
                                'service.title',
                                {
                                    serviceNumber: service,
                                    serviceName: name
                                }
                            ],
                            url: `/services/${service}`
                        });
                        setShowServicePopover(true);
                        // Show stops of the selected service
                        const endStops = [
                            routes[0][0],
                            routes[0][routes[0].length - 1]
                        ];
                        if (routes[1]) endStops.push(routes[1][0], routes[1][routes[1].length - 1]);
                        let routeStops = [
                            ...routes[0],
                            ...routes[1] || []
                        ].filter((el, pos, arr)=>arr.indexOf(el) == pos); // Merge and unique
                        // Fit map to route bounds
                        const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                        routeStops.forEach((stop)=>{
                            const { coordinates } = stopsData[stop];
                            bounds.extend(coordinates);
                        });
                        requestAnimationFrame(()=>{
                            map.fitBounds(bounds, {
                                padding: BREAKPOINT() ? {
                                    top: 80,
                                    right: servicePopover.current.offsetWidth + 80,
                                    bottom: 80,
                                    left: 80
                                } : {
                                    top: 80,
                                    right: 80,
                                    bottom: servicePopover.current.offsetHeight + 20,
                                    left: 80
                                }
                            });
                        });
                        map.getSource('stops-highlight').setData({
                            type: 'FeatureCollection',
                            features: routeStops.map((stop, i)=>{
                                const { name, left } = stopsData[stop];
                                return {
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(stop),
                                    properties: {
                                        name,
                                        number: stop,
                                        type: endStops.includes(stop) ? 'end' : null,
                                        left
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates: stopsData[stop].coordinates
                                    }
                                };
                            })
                        });
                        // Show routes
                        requestAnimationFrame(()=>{
                            const routes = routesData[service];
                            const geometries = routes.map((route)=>(0, _polyline.toGeoJSON)(route));
                            map.getSource('routes').setData({
                                type: 'FeatureCollection',
                                features: geometries.map((geometry)=>({
                                        type: 'Feature',
                                        properties: {},
                                        geometry
                                    }))
                            });
                        });
                    } else {
                        const serviceNumbersNames = services.map((s)=>{
                            const { name } = servicesData[s];
                            return `${s}: ${name}`;
                        }).join(', ');
                        setHead({
                            title: [
                                'service.titleMultiple',
                                {
                                    serviceNumbersNames
                                }
                            ],
                            url: `/services/${services.join('~')}`
                        });
                        let routeStops = [];
                        let endStops = [];
                        let serviceGeometries = [];
                        services.forEach((service)=>{
                            const { routes } = servicesData[service];
                            endStops.push(routes[0][0], routes[0][routes[0].length - 1]);
                            if (routes[1]) endStops.push(routes[1][0], routes[1][routes[1].length - 1]);
                            const allRoutes = [
                                ...routes[0],
                                ...routes[1] || []
                            ].filter((el, pos, arr)=>{
                                return arr.indexOf(el) === pos;
                            });
                            routeStops = routeStops.concat(allRoutes);
                            const routeGeometries = routesData[service];
                            serviceGeometries = serviceGeometries.concat(routeGeometries.map((r)=>({
                                    service,
                                    geometry: (0, _polyline.toGeoJSON)(r)
                                })));
                        });
                        // Merge and unique stops
                        const intersectStops = [];
                        routeStops = routeStops.filter((el, pos, arr)=>{
                            const unique = arr.indexOf(el) === pos;
                            if (!unique && !intersectStops.includes(el)) intersectStops.push(el);
                            return unique;
                        });
                        intersectStops.sort();
                        setIntersectStops(intersectStops);
                        // Fit map to route bounds
                        const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                        routeStops.forEach((stop)=>{
                            const { coordinates } = stopsData[stop];
                            bounds.extend(coordinates);
                        });
                        requestAnimationFrame(()=>{
                            map.fitBounds(bounds, {
                                padding: largerScreen ? {
                                    top: floatPill.current.offsetHeight / 2,
                                    right: 80,
                                    bottom: 80,
                                    left: floatPill.current.offsetHeight / 2
                                } : BREAKPOINT() ? {
                                    top: 80,
                                    right: Math.max(floatPill.current.offsetWidth / 2, 80),
                                    bottom: 80 + floatPill.current.offsetHeight / 2,
                                    left: Math.max(floatPill.current.offsetWidth / 2, 80)
                                } : {
                                    top: 80,
                                    right: 80,
                                    bottom: 80 + floatPill.current.offsetHeight,
                                    // height of search bar + float pill
                                    left: 80
                                }
                            });
                        });
                        map.getSource('stops-highlight').setData({
                            type: 'FeatureCollection',
                            features: routeStops.map((stop, i)=>{
                                const { name, left } = stopsData[stop];
                                return {
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(stop),
                                    properties: {
                                        name,
                                        number: stop,
                                        type: endStops.includes(stop) ? 'end' : intersectStops.includes(stop) ? 'intersect' : null,
                                        left
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates: stopsData[stop].coordinates
                                    }
                                };
                            })
                        });
                        // Show routes
                        requestAnimationFrame(()=>{
                            map.getSource('routes-path').setData({
                                type: 'FeatureCollection',
                                features: serviceGeometries.map((sg)=>({
                                        type: 'Feature',
                                        id: (0, _specialID.encode)(sg.service),
                                        properties: {
                                            service: sg.service
                                        },
                                        geometry: sg.geometry
                                    }))
                            });
                            STORE.routesPathServices = serviceGeometries.map((sg)=>sg.service);
                        });
                    }
                    break;
                }
            case 'stop':
                {
                    const stop = route.value;
                    if (!stopsData[stop]) return;
                    // Reset
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    resetSearch();
                    const { routes, name, coordinates } = stopsData[stop];
                    if (route.subpage === 'routes') {
                        setHead({
                            title: [
                                'stop.titleRoutes',
                                {
                                    stopNumber: stop,
                                    stopName: name
                                }
                            ],
                            url: `/stops/${stop}/routes`
                        });
                        // Hide all stops
                        map.setLayoutProperty('stops', 'visibility', 'none');
                        map.setLayoutProperty('stops-icon', 'visibility', 'none');
                        // Show the all stops in all routes
                        const allStopsCoords = [];
                        allStopsCoords.push(coordinates);
                        const otherStops = new Set();
                        routes.forEach((route)=>{
                            const [service, index] = route.split('-');
                            const stops = servicesData[service].routes[index];
                            stops.forEach((s)=>stop !== s && otherStops.add(s));
                        });
                        [
                            ...otherStops
                        ].map((s)=>{
                            allStopsCoords.push(stopsData[s].coordinates);
                        });
                        // Fit map to route bounds
                        const bounds = new (0, _maplibreGlDefault.default).LngLatBounds();
                        allStopsCoords.forEach((coordinates)=>{
                            bounds.extend(coordinates);
                        });
                        requestAnimationFrame(()=>{
                            map.fitBounds(bounds, {
                                padding: largerScreen ? {
                                    top: floatPill.current.offsetHeight / 2,
                                    right: 80,
                                    bottom: 80,
                                    left: floatPill.current.offsetHeight / 2
                                } : BREAKPOINT() ? {
                                    top: 80,
                                    right: Math.max(floatPill.current.offsetWidth / 2, 80),
                                    bottom: 80 + floatPill.current.offsetHeight / 2,
                                    left: Math.max(floatPill.current.offsetWidth / 2, 80)
                                } : {
                                    top: 80,
                                    right: 80,
                                    bottom: 80 + floatPill.current.offsetHeight,
                                    // height of search bar + float pill
                                    left: 80
                                }
                            });
                        });
                        map.getSource('stops-highlight').setData({
                            type: 'FeatureCollection',
                            features: [
                                {
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(stop),
                                    properties: {
                                        name,
                                        number: stop,
                                        type: 'end',
                                        left: stopsData[stop].left
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates
                                    }
                                }
                            ]
                        });
                        // Show all routes
                        requestAnimationFrame(()=>{
                            const serviceGeometries = routes.map((route)=>{
                                const [service, index] = route.split('-');
                                const line = routesData[service][index];
                                const geometry = (0, _polyline.toGeoJSON)(line);
                                return {
                                    service,
                                    geometry
                                };
                            });
                            map.getSource('routes-path').setData({
                                type: 'FeatureCollection',
                                features: serviceGeometries.map((sg, i)=>({
                                        type: 'Feature',
                                        id: (0, _specialID.encode)(sg.service),
                                        properties: {
                                            service: sg.service
                                        },
                                        geometry: sg.geometry
                                    }))
                            });
                            STORE.routesPathServices = serviceGeometries.map((sg)=>sg.service);
                        });
                    } else {
                        setHead({
                            title: [
                                'stop.title',
                                {
                                    stopNumber: stop,
                                    stopName: name
                                }
                            ],
                            url: `/stops/${stop}`
                        });
                        map.setLayoutProperty('stops', 'visibility', 'visible');
                        map.setLayoutProperty('stops-icon', 'visibility', 'visible');
                        _showStopPopover(stop);
                    }
                    break;
                }
            case 'between':
                {
                    const coords = route.value;
                    const [startStopNumber, endStopNumber] = coords.split(/[,-]/).map(String);
                    if (!stopsData[startStopNumber] || !stopsData[endStopNumber]) {
                        alert('One of the stop numbers are not found.');
                        return;
                    }
                    setHead({
                        title: `Routes between ${startStopNumber} and ${endStopNumber} - ${t('app.name')}`,
                        url: `/between/${startStopNumber}-${endStopNumber}`
                    });
                    // Reset
                    setExpandSearch(false);
                    setShrinkSearch(true);
                    // Hide all stops
                    map.setLayoutProperty('stops', 'visibility', 'none');
                    map.setLayoutProperty('stops-icon', 'visibility', 'none');
                    function findRoutesBetween(startStop, endStop) {
                        const results = [];
                        const endServicesStops = endStop.routes.map((route)=>{
                            const [service, routeIndex] = route.split('-');
                            let serviceStops = servicesData[service].routes[routeIndex];
                            serviceStops = serviceStops.slice(0, serviceStops.indexOf(endStop.number) + 1);
                            return {
                                service,
                                stops: serviceStops,
                                route
                            };
                        });
                        startStop.routes.forEach((route)=>{
                            const [service, routeIndex] = route.split('-');
                            let serviceStops = servicesData[service].routes[routeIndex];
                            serviceStops = serviceStops.slice(serviceStops.indexOf(startStop.number));
                            // This service already can go straight to the end stop,
                            // there's no need to find any connections from end stop
                            if (serviceStops.includes(endStop.number)) results.push({
                                startService: service,
                                startRoute: route,
                                stopsBetween: []
                            });
                            else endServicesStops.forEach(({ service: s, stops, route: r })=>{
                                // console.log(serviceStops, stops);
                                const intersectedStops = (0, _justIntersectDefault.default)(stops, serviceStops);
                                if (intersectedStops.length) {
                                    const startIndex = intersectedStops.indexOf(startStop.number);
                                    if (startIndex > -1) intersectedStops.splice(startIndex, 1);
                                    const endIndex = intersectedStops.indexOf(endStop.number);
                                    if (endIndex > -1) intersectedStops.splice(endIndex, 1);
                                    if (intersectedStops.length) results.push({
                                        startStop,
                                        startService: service,
                                        startRoute: route,
                                        stopsBetween: intersectedStops,
                                        endRoute: r,
                                        endService: s,
                                        endStop
                                    });
                                }
                            });
                        });
                        return results;
                    }
                    function findNearestStops(stop) {
                        let distance = Infinity;
                        let nearestStop = null;
                        for(let i = 0, l = stopsDataArr.length; i < l; i++){
                            const s = stopsDataArr[i];
                            if (s.number !== stop.number) {
                                const d = (0, _getDistanceDefault.default)(...stop.coordinates, ...s.coordinates);
                                if (d < distance) {
                                    distance = d;
                                    nearestStop = s;
                                }
                            }
                        }
                        return nearestStop;
                    }
                    const startStop = stopsData[startStopNumber];
                    const endStop = stopsData[endStopNumber];
                    const nearestEndStop = findNearestStops(endStop);
                    const nearestStartStop = findNearestStops(startStop);
                    _showBetweenPopover({
                        startStop,
                        endStop,
                        nearestStartStop,
                        nearestEndStop,
                        startWalkMins: (0, _getWalkingMinutesDefault.default)(ruler.distance(startStop.coordinates, nearestStartStop.coordinates) * 1000),
                        endWalkMins: (0, _getWalkingMinutesDefault.default)(ruler.distance(endStop.coordinates, nearestEndStop.coordinates) * 1000),
                        results: [
                            findRoutesBetween(startStop, endStop),
                            findRoutesBetween(startStop, nearestEndStop),
                            findRoutesBetween(nearestStartStop, endStop),
                            findRoutesBetween(nearestStartStop, nearestEndStop)
                        ]
                    });
                    break;
                }
            default:
                setHead(defaultHead);
                // Show all stops
                map.setLayoutProperty('stops', 'visibility', 'visible');
                map.setLayoutProperty('stops-icon', 'visibility', 'visible');
        }
        const { pathname, search, hash } = location;
        gtag('config', window._GA_TRACKING_ID, {
            page_path: pathname + search + hash
        });
        setRouteLoading(false);
    };
    const setStartStop = (number)=>{
        if (betweenEndStop && betweenEndStop != number) location.hash = `/between/${number}-${betweenEndStop}`;
        else {
            setBetweenStartStop(number);
            setBetweenEndStop(null);
        }
    };
    const setEndStop = (number)=>{
        if (betweenStartStop && betweenStartStop != number) location.hash = `/between/${betweenStartStop}-${number}`;
        else {
            setBetweenStartStop(null);
            setBetweenEndStop(number);
        }
    };
    const resetStartEndStops = ()=>{
        setBetweenStartStop(null);
        setBetweenEndStop(null);
    };
    const [mapLoaded, setMapLoaded] = (0, _hooks.useState)(false);
    const onLoad = async ()=>{
        window.onhashchange = ()=>{
            setRoute((0, _getRouteDefault.default)());
            renderRoute();
        };
        const fetchStopsP = (0, _fetchCacheDefault.default)(stopsJSONPath, CACHE_TIME);
        const fetchServicesP = (0, _fetchCacheDefault.default)(servicesJSONPath, CACHE_TIME);
        const fetchRoutesP = (0, _fetchCacheDefault.default)(routesJSONPath, CACHE_TIME);
        // Init data
        const stops = await fetchStopsP;
        Object.keys(stops).forEach((number)=>{
            const stop = stops[number];
            const [lng, lat, name] = stop;
            let left = false;
            if (/[19]$/.test(number)) {
                const oppositeNumber = number.replace(/[19]$/, (d)=>d === '1' ? 9 : 1);
                const oppositeStop = stops[oppositeNumber];
                if (oppositeStop) {
                    const bearing = ruler.bearing([
                        lng,
                        lat
                    ], [
                        oppositeStop[0],
                        oppositeStop[1]
                    ]);
                    left = bearing > 0;
                }
            }
            stopsData[number] = {
                name,
                number,
                interchange: /\sint$/i.test(name) && !/^(bef|aft|opp|bet)\s/i.test(name),
                coordinates: [
                    lng,
                    lat
                ],
                services: [],
                routes: [],
                left
            };
            stopsDataArr.push(stopsData[number]);
        });
        stopsDataArr.sort((a, b)=>a.interchange ? 1 : b.interchange ? -1 : 0);
        servicesData = await fetchServicesP;
        Object.keys(servicesData).forEach((number)=>{
            const { name, routes } = servicesData[number];
            servicesDataArr.push({
                number,
                name
            });
            routes.forEach((route, i)=>{
                route.forEach((stop)=>{
                    if (stopsData[stop] && !stopsData[stop].services.includes(number)) {
                        stopsData[stop].services.push(number);
                        stopsData[stop].routes.push(number + '-' + i);
                    }
                });
            });
        });
        servicesDataArr.sort((a, b)=>(0, _bus.sortServices)(a.number, b.number));
        routesData = await fetchRoutesP;
        setServices(servicesDataArr);
        window._data = {
            servicesData,
            stopsData,
            stopsDataArr,
            routesData,
            servicesDataArr
        };
        const mapLang = ()=>{
            // There's only en and zh, Don't have ms yet
            return ({
                zh: 'zh-Hans'
            })[i18n.resolvedLanguage] || i18n.resolvedLanguage;
        };
        // Set up PMTiles protocol
        let protocol = new (0, _pmtiles.Protocol)();
        (0, _maplibreGlDefault.default).addProtocol('pmtiles', protocol.tile);
        // Create map style
        const mapStyle = (0, _mapStyle.createMapStyle)({
            lang: mapLang()
        });
        map = window._map = new (0, _maplibreGlDefault.default).Map({
            container: 'map',
            style: mapStyle,
            renderWorldCopies: false,
            boxZoom: false,
            minZoom: 8,
            logoPosition: 'bottom-left',
            attributionControl: false,
            pitchWithRotate: false,
            dragRotate: supportsTouch,
            touchPitch: false,
            bounds: [
                lowerLong,
                lowerLat,
                upperLong,
                upperLat
            ],
            fitBoundsOptions: {
                padding: BREAKPOINT() ? 120 : {
                    top: 40,
                    bottom: window.innerHeight / 2,
                    left: 40,
                    right: 40
                }
            }
        });
        if (!supportsTouch) map.touchZoomRotate.disableRotation();
        // Controls
        map.addControl(new (0, _maplibreGlDefault.default).AttributionControl({
            compact: true
        }), 'bottom-left');
        map.addControl(new (0, _geolocateControlDefault.default)({
            offset: ()=>{
                if (!BREAKPOINT()) {
                    if (stopPopover.current?.classList.contains('expand')) return [
                        0,
                        -stopPopover.current.offsetHeight / 2
                    ];
                    else if (servicePopover.current?.classList.contains('expand')) return [
                        0,
                        -servicePopover.current.offsetHeight / 2
                    ];
                    else if (betweenPopover.current?.classList.contains('expand')) return [
                        0,
                        -betweenPopover.current.offsetHeight / 2
                    ];
                }
                return [
                    0,
                    0
                ];
            }
        }), 'top-right');
        map.addControl(new (0, _maplibreGlDefault.default).NavigationControl({
            showCompass: true,
            showZoom: !supportsTouch
        }), 'top-right');
        const compassButton = document.querySelector('.maplibregl-ctrl-compass');
        map.on('rotateend', ()=>{
            const bearing = map.getBearing();
            compassButton.classList.toggle('show', bearing !== 0);
        });
        const language = new (0, _mapboxGlLanguageDefault.default)({
            supportedLanguages: [
                'en',
                'zh-Hans',
                'ms',
                'ta',
                'ja'
            ],
            defaultLanguage: mapLang()
        });
        map.addControl(language);
        i18n.on('languageChanged', ()=>{
            const localizedStyle = language.setLanguage(map.getStyle(), mapLang());
            map.setStyle(localizedStyle);
        });
        // Handle map errors gracefully (suppress mapbox:// URL errors)
        // map.on('error', (e) => {
        //   // Suppress errors related to mapbox:// URLs that can't be loaded in maplibre-gl
        //   if (e.error && e.error.message && e.error.message.includes('mapbox://')) {
        //     console.warn('Suppressed mapbox:// URL error (expected with maplibre-gl):', e.error.message);
        //     return;
        //   }
        //   // Suppress 422 errors for composite tilesets that may not be accessible
        //   if (e.error && e.error.status === 422 && e.error.url && e.error.url.includes('api.mapbox.com/v4/')) {
        //     console.warn('Suppressed 422 error for tileset (may not be accessible):', e.error.url);
        //     return;
        //   }
        //   // Suppress InvalidStateError for sprite decoding issues
        //   if (e.error && e.error.name === 'InvalidStateError' && e.error.message.includes('source image could not be decoded')) {
        //     console.warn('Suppressed sprite decoding error (expected with maplibre-gl):', e.error.message);
        //     return;
        //   }
        //   // Log other errors normally
        //   console.error('Map error:', e.error);
        // });
        let initialMoveStart = false;
        const initialHideSearch = ()=>{
            if (initialMoveStart) return;
            initialMoveStart = true;
            $logo.classList.add('fadeout');
            setShrinkSearch(true);
        };
        map.once('dragstart', initialHideSearch);
        map.once('zoomstart', initialHideSearch);
        await new Promise((resolve, reject)=>{
            map.once('styledata', ()=>{
                const layers = map.getStyle().layers;
                labelLayerId = layers.find((l)=>l.type == 'symbol' && l.layout['text-field']).id;
                resolve();
            });
        });
        // const localizedStyle = language.setLanguage(map.getStyle(), 'zh-Hans');
        // map.setStyle(localizedStyle);
        if (window.performance) {
            const timeSincePageLoad = Math.round(performance.now());
            gtag('event', 'timing_complete', {
                name: 'load',
                value: timeSincePageLoad,
                event_category: 'Map'
            });
        }
        map.loadImage((0, _stopPngDefault.default)).then((img)=>{
            map.addImage('stop', img.data);
        }).catch((e)=>{});
        map.loadImage((0, _stopEndPngDefault.default)).then((img)=>{
            map.addImage('stop-end', img.data);
        }).catch((e)=>{});
        map.loadImage((0, _mrtStationPngDefault.default)).then((img)=>{
            map.addImage('mrt-station', img.data);
        }).catch((e)=>{});
        map.loadImage((0, _lrtStationPngDefault.default)).then((img)=>{
            map.addImage('lrt-station', img.data);
        }).catch((e)=>{});
        // Add rail lines layer
        map.addLayer({
            id: 'rail-path',
            type: 'line',
            source: 'sg-rail',
            filter: [
                'all',
                [
                    '==',
                    [
                        'geometry-type'
                    ],
                    'LineString'
                ],
                [
                    'has',
                    'line_color'
                ]
            ],
            minzoom: 12.5,
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': [
                    'to-color',
                    [
                        'get',
                        'line_color'
                    ]
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0.5,
                    16,
                    1.5,
                    22,
                    2
                ],
                'line-opacity': 0.5
            }
        }, labelLayerId);
        map.addLayer({
            id: 'rail-path-case',
            type: 'line',
            source: 'sg-rail',
            filter: [
                'all',
                [
                    '==',
                    [
                        'geometry-type'
                    ],
                    'LineString'
                ],
                [
                    'has',
                    'line_color'
                ]
            ],
            minzoom: 13,
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#fff',
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    16,
                    4.5,
                    22,
                    6
                ],
                'line-opacity': 0.5
            }
        }, 'rail-path');
        map.addLayer({
            id: 'rail-path-label',
            type: 'symbol',
            source: 'sg-rail',
            filter: [
                'all',
                [
                    '==',
                    [
                        'geometry-type'
                    ],
                    'LineString'
                ],
                [
                    'has',
                    'line_color'
                ]
            ],
            minzoom: 13,
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 300,
                'text-field': [
                    'get',
                    'name'
                ],
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-size': 13
            },
            paint: {
                'text-color': [
                    'to-color',
                    [
                        'get',
                        'line_color'
                    ]
                ],
                'text-halo-color': '#fff',
                'text-halo-width': 2
            }
        });
        // Add rail stations layer using pois icon style
        map.addLayer({
            id: 'rail-stations',
            type: 'symbol',
            source: 'sg-rail',
            filter: [
                'all',
                [
                    '==',
                    [
                        'geometry-type'
                    ],
                    'Point'
                ],
                [
                    '==',
                    [
                        'get',
                        'stop_type'
                    ],
                    'station'
                ]
            ],
            minzoom: 13,
            layout: {
                'icon-image': [
                    'case',
                    [
                        '==',
                        [
                            'get',
                            'network'
                        ],
                        'singapore-lrt'
                    ],
                    'lrt-station',
                    'mrt-station'
                ],
                'icon-size': 0.2,
                'icon-allow-overlap': false,
                'text-field': [
                    'coalesce',
                    [
                        'get',
                        'name_en'
                    ],
                    [
                        'get',
                        'name'
                    ]
                ],
                'text-font': [
                    'Noto Sans Medium'
                ],
                'text-size': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    0,
                    0,
                    22,
                    16
                ],
                'text-variable-anchor': [
                    'left',
                    'right',
                    'top'
                ],
                'text-radial-offset': 0.85,
                'text-optional': true
            },
            paint: {
                'text-color': '#4d787e',
                'text-halo-color': '#fff',
                'text-halo-width': 1
            }
        });
        setMapLoaded(true);
    };
    (0, _hooks.useEffect)(()=>{
        onLoad();
    }, []);
    (0, _hooks.useEffect)(()=>{
        if (!mapLoaded) return;
        const mapCanvas = map.getCanvas();
        map.addSource('stops', {
            type: 'geojson',
            tolerance: 10,
            buffer: 0,
            attribution: '\xa9 <a href="https://www.lta.gov.sg/" target="_blank" title="Land Transport Authority">LTA</a>',
            data: {
                type: 'FeatureCollection',
                features: stopsDataArr.map((stop)=>({
                        type: 'Feature',
                        id: (0, _specialID.encode)(stop.number),
                        properties: {
                            number: stop.number,
                            name: stop.name,
                            interchange: stop.interchange,
                            left: stop.left
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: stop.coordinates
                        }
                    }))
            }
        });
        const stopTextPartialFormat = [
            'get',
            'number'
        ];
        const stopTextFullFormat = [
            'format',
            [
                'get',
                'number'
            ],
            {
                'font-scale': 0.8
            },
            '\n',
            {},
            [
                'get',
                'name'
            ],
            {
                'text-color': '#000'
            }
        ];
        const stopText = {
            layout: {
                'text-optional': true,
                'text-field': [
                    'step',
                    [
                        'zoom'
                    ],
                    '',
                    15,
                    stopTextPartialFormat,
                    16,
                    stopTextFullFormat
                ],
                'text-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    12,
                    16,
                    14
                ],
                'text-justify': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-anchor': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    'right',
                    'left'
                ],
                'text-offset': [
                    'case',
                    [
                        'boolean',
                        [
                            'get',
                            'left'
                        ],
                        false
                    ],
                    [
                        'literal',
                        [
                            -1,
                            0
                        ]
                    ],
                    [
                        'literal',
                        [
                            1,
                            0
                        ]
                    ]
                ],
                // 'text-justify': 'auto',
                // 'text-variable-anchor': ['left', 'right'],
                // 'text-radial-offset': 1,
                'text-padding': 0.5,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Medium'
                ],
                'text-max-width': 16,
                'text-line-height': 1.1
            },
            paint: {
                'text-color': '#f01b48',
                'text-halo-width': 1,
                'text-halo-color': '#fff'
            }
        };
        map.addLayer({
            id: 'stops',
            type: 'circle',
            source: 'stops',
            layout: {
                visibility: 'none'
            },
            paint: {
                'circle-radius': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        4,
                        0.75
                    ],
                    14,
                    4,
                    15,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        12,
                        6
                    ]
                ],
                'circle-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    '#fff',
                    '#f01b48'
                ],
                'circle-stroke-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    '#f01b48',
                    '#fff'
                ],
                'circle-stroke-width': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    5,
                    1
                ],
                'circle-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    1,
                    13.9,
                    1,
                    14,
                    0.5
                ],
                'circle-stroke-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    [
                        'case',
                        [
                            'boolean',
                            [
                                'feature-state',
                                'selected'
                            ],
                            false
                        ],
                        1,
                        0
                    ],
                    13.5,
                    1,
                    14,
                    0.5
                ]
            }
        }, 'places_subplace');
        map.addLayer({
            id: 'stops-icon',
            type: 'symbol',
            source: 'stops',
            filter: [
                'any',
                [
                    '>=',
                    [
                        'zoom'
                    ],
                    14
                ],
                [
                    'get',
                    'interchange'
                ]
            ],
            layout: {
                visibility: 'none',
                // 'symbol-z-order': 'source',
                'icon-image': 'stop',
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.4,
                    15,
                    0.5,
                    16,
                    0.6
                ],
                // 'icon-size': ['interpolate', ['linear'], ['zoom'], 14, 0.4, 16, 0.6],
                'icon-padding': 0.5,
                'icon-allow-overlap': true,
                // 'icon-ignore-placement': true,
                ...stopText.layout
            },
            paint: {
                'icon-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    8,
                    [
                        'case',
                        [
                            'get',
                            'interchange'
                        ],
                        1,
                        0
                    ],
                    14,
                    1
                ],
                ...stopText.paint
            }
        });
        requestIdleCallback(()=>{
            map.on('mouseenter', 'stops', ()=>{
                mapCanvas.style.cursor = 'pointer';
            });
            let lastFrame = null;
            if (supportsHover) {
                let lastFeature = null;
                map.on('mousemove', (e)=>{
                    const { point } = e;
                    const features = map.queryRenderedFeatures(point, {
                        layers: [
                            'stops',
                            'stops-highlight'
                        ],
                        validate: false
                    });
                    if (features.length && map.getZoom() < 16 && !map.isMoving()) {
                        if (lastFeature && features[0].id === lastFeature.id) return;
                        lastFeature = features[0];
                        const stopID = (0, _specialID.decode)(features[0].id);
                        const data = stopsData[stopID];
                        if (lastFrame) cancelAnimationFrame(lastFrame);
                        lastFrame = requestAnimationFrame(()=>{
                            showStopTooltip({
                                ...data,
                                ...point
                            });
                        });
                    } else if (lastFeature) {
                        lastFeature = null;
                        hideStopTooltip();
                    }
                });
            }
            map.on('mouseleave', 'stops', ()=>{
                mapCanvas.style.cursor = '';
                if (lastFrame) cancelAnimationFrame(lastFrame);
                requestAnimationFrame(hideStopTooltip);
            });
            map.on('mouseout', hideStopTooltip);
            map.on('movestart', hideStopTooltip);
        });
        map.addSource('stops-highlight', {
            type: 'geojson',
            tolerance: 10,
            buffer: 0,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'stops-highlight-circle',
            type: 'circle',
            source: 'stops-highlight',
            minzoom: 11,
            maxzoom: 14,
            filter: [
                'all',
                [
                    '!=',
                    [
                        'get',
                        'type'
                    ],
                    'end'
                ],
                [
                    '!=',
                    [
                        'get',
                        'type'
                    ],
                    'intersect'
                ]
            ],
            paint: {
                'circle-radius': [
                    'step',
                    [
                        'zoom'
                    ],
                    1.5,
                    12,
                    2
                ],
                'circle-color': '#fff',
                'circle-stroke-color': '#f01b48',
                'circle-stroke-width': [
                    'step',
                    [
                        'zoom'
                    ],
                    1.5,
                    12,
                    2
                ]
            }
        });
        map.addLayer({
            id: 'stops-highlight',
            type: 'symbol',
            source: 'stops-highlight',
            filter: [
                'any',
                [
                    '>=',
                    [
                        'zoom'
                    ],
                    14
                ],
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'end'
                ],
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'intersect'
                ]
            ],
            layout: {
                'icon-image': [
                    'case',
                    [
                        '==',
                        [
                            'get',
                            'type'
                        ],
                        'end'
                    ],
                    'stop-end',
                    [
                        '==',
                        [
                            'get',
                            'type'
                        ],
                        'intersect'
                    ],
                    'stop-end',
                    'stop'
                ],
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.3,
                    10,
                    [
                        'case',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        0.3,
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'intersect'
                        ],
                        0.25,
                        0.45
                    ],
                    15,
                    [
                        'case',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        0.45,
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'intersect'
                        ],
                        0.4,
                        0.6
                    ]
                ],
                'icon-anchor': [
                    'case',
                    [
                        '==',
                        [
                            'get',
                            'type'
                        ],
                        'end'
                    ],
                    'bottom',
                    [
                        '==',
                        [
                            'get',
                            'type'
                        ],
                        'intersect'
                    ],
                    'bottom',
                    'center'
                ],
                'icon-padding': 0.5,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                ...stopText.layout,
                'text-field': [
                    'step',
                    [
                        'zoom'
                    ],
                    [
                        'case',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        stopTextFullFormat,
                        ''
                    ],
                    14,
                    [
                        'case',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        stopTextFullFormat,
                        stopTextPartialFormat
                    ],
                    16,
                    stopTextFullFormat
                ],
                'text-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    [
                        'case',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        14,
                        11
                    ],
                    16,
                    14
                ]
            },
            paint: {
                ...stopText.paint,
                'text-halo-width': [
                    'case',
                    [
                        '==',
                        [
                            'get',
                            'type'
                        ],
                        'end'
                    ],
                    2,
                    1
                ]
            }
        });
        map.addLayer({
            id: 'stops-highlight-selected',
            type: 'circle',
            source: 'stops-highlight',
            filter: [
                'any',
                [
                    '>',
                    [
                        'zoom'
                    ],
                    10
                ],
                [
                    '==',
                    [
                        'get',
                        'type'
                    ],
                    'end'
                ]
            ],
            paint: {
                'circle-radius': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    10,
                    4,
                    15,
                    [
                        'case',
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'end'
                        ],
                        4,
                        [
                            '==',
                            [
                                'get',
                                'type'
                            ],
                            'intersect'
                        ],
                        4,
                        12
                    ]
                ],
                'circle-color': '#fff',
                'circle-stroke-color': '#f01b48',
                'circle-stroke-width': 5,
                'circle-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    0.5,
                    0
                ],
                'circle-stroke-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'selected'
                        ],
                        false
                    ],
                    0.5,
                    0
                ]
            }
        }, 'stops-highlight');
        requestIdleCallback(()=>{
            map.on('mouseenter', 'stops-highlight', ()=>{
                mapCanvas.style.cursor = 'pointer';
            });
            map.on('mouseleave', 'stops-highlight', ()=>{
                mapCanvas.style.cursor = '';
            });
        });
        // Bus service routes
        map.addSource('routes', {
            type: 'geojson',
            tolerance: 1,
            buffer: 0,
            lineMetrics: true,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'routes',
            type: 'line',
            source: 'routes',
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#f01b48',
                'line-gradient': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'line-progress'
                    ],
                    0,
                    '#f01b48',
                    0.5,
                    '#972FFE',
                    1,
                    '#f01b48'
                ],
                'line-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0.9,
                    16,
                    0.4
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ],
                'line-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    16,
                    -3,
                    22,
                    [
                        '*',
                        [
                            'zoom'
                        ],
                        -3
                    ]
                ]
            }
        }, 'stops');
        map.addLayer({
            id: 'routes-bg',
            type: 'line',
            source: 'routes',
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#fff',
                'line-opacity': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    1,
                    22,
                    0
                ],
                'line-width': 6,
                'line-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    16,
                    -3,
                    22,
                    [
                        '*',
                        [
                            'zoom'
                        ],
                        -3
                    ]
                ]
            }
        }, 'routes');
        map.addLayer({
            id: 'route-arrows',
            type: 'symbol',
            source: 'routes',
            minzoom: 12,
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 100,
                'text-field': "\u2192",
                'text-size': 16,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Medium'
                ],
                'text-allow-overlap': true,
                'text-ignore-placement': true,
                'text-keep-upright': false,
                'text-anchor': 'bottom',
                'text-padding': 0,
                'text-line-height': 1,
                'text-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    [
                        'literal',
                        [
                            0,
                            0
                        ]
                    ],
                    22,
                    [
                        'literal',
                        [
                            0,
                            -2
                        ]
                    ]
                ]
            },
            paint: {
                'text-color': '#5301a4',
                'text-opacity': 0.9,
                'text-halo-color': '#fff',
                'text-halo-width': 2
            }
        }, 'stops');
        // Bus service routes (passing, overlapping)
        map.addSource('routes-path', {
            type: 'geojson',
            tolerance: 1,
            buffer: 0,
            lineMetrics: true,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'routes-path',
            type: 'line',
            source: 'routes-path',
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': '#f01b48',
                'line-gradient': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'line-progress'
                    ],
                    0,
                    '#f01b48',
                    0.5,
                    '#972FFE',
                    1,
                    '#f01b48'
                ],
                'line-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'hover'
                        ],
                        false
                    ],
                    1,
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    0.07,
                    0.5 // default
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ]
            }
        }, 'stops');
        map.addLayer({
            id: 'routes-path-bg',
            type: 'line',
            source: 'routes-path',
            layout: {
                'line-cap': 'round'
            },
            maxzoom: 20,
            paint: {
                'line-color': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    'transparent',
                    '#fff'
                ],
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    6,
                    16,
                    10,
                    22,
                    16
                ]
            }
        }, 'routes-path');
        map.addLayer({
            id: 'route-path-labels',
            type: 'symbol',
            source: 'routes-path',
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 300,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Medium'
                ],
                'text-field': '{service}',
                'text-size': 14,
                'text-rotation-alignment': 'viewport',
                'text-padding': 0,
                'text-line-height': 1
            },
            paint: {
                'text-color': '#3a6727',
                'text-halo-color': '#eeffd1',
                'text-halo-width': 2,
                'text-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    0.1,
                    1
                ]
            }
        });
        map.addLayer({
            id: 'route-path-arrows',
            type: 'symbol',
            source: 'routes-path',
            minzoom: 12,
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 200,
                'text-field': "\u2192",
                'text-size': 16,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Medium'
                ],
                // 'text-allow-overlap': true,
                // 'text-ignore-placement': true,
                'text-keep-upright': false,
                'text-anchor': 'bottom',
                'text-padding': 0,
                'text-line-height': 1,
                'text-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    [
                        'literal',
                        [
                            0,
                            0
                        ]
                    ],
                    22,
                    [
                        'literal',
                        [
                            0,
                            -2
                        ]
                    ]
                ]
            },
            paint: {
                'text-color': '#5301a4',
                'text-opacity': 0.9,
                'text-halo-color': '#fff',
                'text-halo-width': 2,
                'text-opacity': [
                    'case',
                    [
                        'boolean',
                        [
                            'feature-state',
                            'fadein'
                        ],
                        false
                    ],
                    0.1,
                    1
                ]
            }
        }, 'stops');
        requestIdleCallback(()=>{
            let hoveredRouteID;
            map.on('mouseenter', 'routes-path', ()=>{
                mapCanvas.style.cursor = 'pointer';
            });
            map.on('click', 'routes-path', (e)=>{
                if (e.features.length) {
                    const { id } = e.features[0];
                    location.hash = `/services/${(0, _specialID.decode)(id)}`;
                }
            });
            map.on('mousemove', 'routes-path', (e)=>{
                if (e.features.length) {
                    const currentHoveredRouteID = e.features[0].id;
                    if (hoveredRouteID && hoveredRouteID === currentHoveredRouteID) return;
                    if (hoveredRouteID) map.setFeatureState({
                        source: 'routes-path',
                        id: hoveredRouteID
                    }, {
                        hover: false,
                        fadein: false
                    });
                    hoveredRouteID = currentHoveredRouteID;
                    map.setFeatureState({
                        source: 'routes-path',
                        id: hoveredRouteID
                    }, {
                        hover: true,
                        fadein: false
                    });
                    STORE.routesPathServices?.forEach((service)=>{
                        const id = (0, _specialID.encode)(service);
                        if (hoveredRouteID === id) return;
                        map.setFeatureState({
                            source: 'routes-path',
                            id
                        }, {
                            hover: false,
                            fadein: true
                        });
                    });
                    highlightRouteTag((0, _specialID.decode)(hoveredRouteID));
                }
            });
            map.on('mouseleave', 'routes-path', ()=>{
                mapCanvas.style.cursor = '';
                if (hoveredRouteID) {
                    STORE.routesPathServices?.forEach((service)=>{
                        const id = (0, _specialID.encode)(service);
                        map.setFeatureState({
                            source: 'routes-path',
                            id
                        }, {
                            fadein: false,
                            hover: false
                        });
                    });
                    hoveredRouteID = null;
                    highlightRouteTag();
                }
            });
        });
        // Service live buses
        map.addSource('buses-service', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.loadImage((0, _busTinyPngDefault.default)).then((img)=>{
            map.addImage('bus-tiny', img.data);
        }).catch((e)=>{});
        map.addLayer({
            id: 'buses-service',
            type: 'symbol',
            source: 'buses-service',
            minzoom: 9,
            layout: {
                'icon-image': 'bus-tiny',
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.3,
                    14,
                    0.35,
                    15,
                    0.45,
                    16,
                    0.55
                ]
            }
        });
        // Between routes
        map.addSource('routes-between', {
            type: 'geojson',
            tolerance: 1,
            buffer: 0,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        map.addLayer({
            id: 'routes-between',
            type: 'line',
            source: 'routes-between',
            filter: [
                '!=',
                [
                    'get',
                    'type'
                ],
                'walk'
            ],
            layout: {
                'line-cap': 'round'
            },
            paint: {
                'line-color': [
                    'match',
                    [
                        'get',
                        'type'
                    ],
                    'start',
                    '#f01b48',
                    'end',
                    '#972FFE',
                    '#f01b48'
                ],
                'line-opacity': 0.7,
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ],
                'line-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    0,
                    16,
                    -3,
                    22,
                    [
                        '*',
                        [
                            'zoom'
                        ],
                        -3
                    ]
                ]
            }
        }, 'stops');
        map.addLayer({
            id: 'routes-between-walk',
            type: 'line',
            source: 'routes-between',
            filter: [
                '==',
                [
                    'get',
                    'type'
                ],
                'walk'
            ],
            paint: {
                'line-color': '#007aff',
                'line-dasharray': [
                    2,
                    2
                ],
                'line-opacity': 0.7,
                'line-width': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    2,
                    16,
                    5,
                    22,
                    10
                ]
            }
        }, 'stops-highlight');
        map.addLayer({
            id: 'routes-between-bg',
            type: 'line',
            source: 'routes-between',
            layout: {
                'line-cap': 'round'
            },
            maxzoom: 14,
            paint: {
                'line-color': '#fff',
                'line-width': 6
            }
        }, 'routes-between');
        map.addLayer({
            id: 'route-between-arrows',
            type: 'symbol',
            source: 'routes-between',
            minzoom: 12,
            layout: {
                'symbol-placement': 'line',
                'symbol-spacing': 100,
                'text-field': "\u2192",
                'text-size': 16,
                'text-allow-overlap': true,
                'text-ignore-placement': true,
                'text-keep-upright': false,
                'text-anchor': 'bottom',
                'text-padding': 0,
                'text-line-height': 1,
                'text-offset': [
                    'interpolate',
                    [
                        'linear'
                    ],
                    [
                        'zoom'
                    ],
                    12,
                    [
                        'literal',
                        [
                            0,
                            0
                        ]
                    ],
                    22,
                    [
                        'literal',
                        [
                            0,
                            -2
                        ]
                    ]
                ]
            },
            paint: {
                'text-color': '#5301a4',
                'text-opacity': 0.8,
                'text-halo-color': '#fff',
                'text-halo-width': 2
            }
        });
        renderRoute();
        // Popover search field
        fuseServices = new (0, _fuseJsDefault.default)(servicesDataArr, {
            threshold: 0.3,
            keys: [
                'number',
                'name'
            ]
        });
        fuseStops = new (0, _fuseJsDefault.default)(stopsDataArr, {
            threshold: 0.3,
            keys: [
                'number',
                'name'
            ]
        });
        requestIdleCallback(()=>{
            // For cases when user already typed something before fuse.js inits
            if (searchField.current?.value) handleSearch();
            // Finally, show ad
            map.once('idle', ()=>{
                setTimeout(()=>{
                    setShowAd(true);
                }, 1000);
            });
        });
    }, [
        mapLoaded
    ]);
    (0, _hooks.useEffect)(()=>{
        if (!mapLoaded) return;
        const handleMapClick = (e)=>{
            if (e.originalEvent.altKey) {
                const layers = map.queryRenderedFeatures(e.point, {
                    validate: false
                });
            }
            const { point } = e;
            const features = map.queryRenderedFeatures(point, {
                layers: [
                    'stops',
                    'stops-icon',
                    'stops-highlight'
                ],
                validate: false
            });
            if (features.length) {
                const zoom = map.getZoom();
                const feature = features[0];
                const center = feature.geometry.coordinates;
                if (zoom < 12) {
                    // Slowly zoom in first
                    map.flyTo({
                        zoom: zoom + 2,
                        center
                    });
                    setShrinkSearch(true);
                } else if (feature.source == 'stops') location.hash = `/stops/${feature.properties.number}`;
                else _showStopPopover(feature.properties.number);
            } else {
                const { page, subpage } = route;
                if (page === 'stop' && subpage !== 'routes') location.hash = '/';
                else hideStopPopover();
            }
        };
        map.on('click', handleMapClick);
        return ()=>map.off('click', handleMapClick);
    }, [
        mapLoaded,
        route.page,
        route.subpage,
        _showStopPopover,
        hideStopPopover
    ]);
    const popoverIsUp = (0, _hooks.useMemo)(()=>(!!showStopPopover || !!showBetweenPopover || !!showArrivalsPopover || !!showServicePopover) && !largerScreen, [
        showStopPopover,
        showBetweenPopover,
        showArrivalsPopover,
        showServicePopover,
        largerScreen
    ]);
    // Global shortcuts
    (0, _hooks.useEffect)(()=>{
        const handler = (e)=>{
            const isFormField = e.target && e.target.tagName && /input|textarea|button|select/i.test(e.target.tagName);
            const keydown = e.key.toLowerCase();
            switch(keydown){
                case '/':
                    if (isFormField) return;
                    if (popoverIsUp) return;
                    e.preventDefault();
                    searchField.current.focus();
                    break;
                case 'escape':
                    if (expandSearch) handleSearchClose();
                    else if (showStopPopover) hideStopPopover();
                    else if (showBetweenPopover) location.hash = '/';
                    else if (showServicePopover) location.hash = '/';
                    break;
                default:
                    if (e.shiftKey && e.altKey) document.body.classList.add('alt-mode');
            }
        };
        document.addEventListener('keydown', handler);
        return ()=>document.removeEventListener('keydown', handler);
    }, [
        expandSearch,
        showStopPopover,
        showBetweenPopover,
        showServicePopover,
        popoverIsUp
    ]);
    document.addEventListener('keyup', ()=>{
        document.body.classList.remove('alt-mode');
    });
    const showServicesFloatPill = route.page === 'service' && servicesData && routeServices.length > 1;
    const showPassingRoutesFloatPill = route.page === 'stop' && route.subpage === 'routes' && stopsData && stopsData[route.value];
    return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)((0, _aboutDefault.default), null), (0, _preact.h)("div", {
        id: "search-popover",
        ref: searchPopover,
        class: `popover ${expandSearch ? 'expand' : ''} ${shrinkSearch ? 'shrink' : ''} ${routeLoading ? 'loading' : ''}`
    }, (0, _preact.h)("div", {
        id: "popover-float",
        hidden: !(showServicesFloatPill || showPassingRoutesFloatPill)
    }, (0, _preact.h)("div", {
        class: "float-pill",
        ref: floatPill
    }, (0, _preact.h)("a", {
        href: "#/",
        class: "popover-close"
    }, "\xD7"), showServicesFloatPill && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("div", {
        class: "service-flex"
    }, (0, _preact.h)("h1", null, t('multiRoute.showingServices', {
        count: routeServices.length
    }))), (0, _preact.h)("div", {
        class: "services-list"
    }, (0, _preact.h)("div", null, routeServices.sort((0, _bus.sortServices)).map((service)=>(0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
            href: `#/services/${service}`,
            onClick: (e)=>clickRoute(e, service),
            onMouseEnter: (e)=>highlightRoute(e, service),
            onMouseLeave: unhighlightRoute,
            class: "service-tag",
            "data-service": service
        }, service, (0, _preact.h)("span", {
            class: "close",
            title: "Remove this service",
            onClick: (e)=>{
                e.preventDefault();
                e.stopPropagation();
                const newRouteServices = routeServices.filter((s)=>s !== service);
                location.hash = `/services/${newRouteServices.join('~')}`;
                unhighlightRoute();
            }
        }, "\xD7")))), (0, _preact.h)("button", {
        type: "button",
        class: "plus",
        onClick: ()=>{
            setExpandSearch(true);
            setExpandedSearchOnce(true);
        },
        title: t('multiRoute.addRoute')
    })), !!intersectStops.length && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("h2", null, t('multiRoute.intersectingStops', {
        count: intersectStops.length
    })), (0, _preact.h)("ul", {
        class: "simple-stops-list"
    }, intersectStops.map((s)=>{
        const stop = stopsData[s];
        return (0, _preact.h)("li", {
            key: stop.number
        }, (0, _preact.h)("a", {
            href: `#/stops/${stop.number}`,
            onClick: (e)=>{
                e.preventDefault();
                zoomToStop(s);
            // onStopClickAgain={_showStopPopover}
            }
        }, (0, _preact.h)("b", {
            class: "stop-tag"
        }, stop.number), ' ', (0, _preact.h)("span", {
            class: "stop-name"
        }, stop.name), ' ', routeServices.length > 2 && (0, _preact.h)("span", {
            class: "services-meta-list"
        }, stopsData[stop.number].services.filter((s)=>routeServices.includes(s)).sort((0, _bus.sortServices)).join(' '))));
    }))))), showPassingRoutesFloatPill && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("div", {
        class: "service-flex"
    }, (0, _preact.h)("span", {
        class: "stop-tag"
    }, route.value), (0, _preact.h)("div", null, (0, _preact.h)("h1", null, stopsData[route.value].name))), (0, _preact.h)("div", {
        class: "services-list",
        onClick: unhighlightRoute
    }, (0, _preact.h)("h2", null, t('passingRoutes.passingRoutes', {
        count: stopsData[route.value].services.length
    }), ' ', "\xB7", ' ', (0, _preact.h)("a", {
        href: `#/services/${stopsData[route.value].services.sort((0, _bus.sortServices)).join('~')}`
    }, t('glossary.multiRouteMode'), " \u2295")), stopsData[route.value].services.sort((0, _bus.sortServices)).map((service)=>(0, _preact.h)("a", {
            href: `#/services/${service}`,
            onClick: (e)=>clickRoute(e, service),
            onMouseEnter: (e)=>highlightRoute(e, service),
            onMouseLeave: unhighlightRoute,
            class: "service-tag",
            "data-service": service
        }, service)))))), (0, _preact.h)("div", {
        class: "popover-inner"
    }, (0, _preact.h)("div", {
        class: "popover-search"
    }, (0, _preact.h)("input", {
        type: "search",
        placeholder: t('search.placeholder'),
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false",
        ref: searchField,
        onfocus: handleSearchFocus,
        oninput: handleSearch,
        onkeydown: handleKeys,
        disabled: !searching && !services.length
    }), (0, _preact.h)("button", {
        type: "button",
        onclick: handleSearchClose
    }, t('common.cancel'))), (0, _preact.h)("ul", {
        class: `popover-list ${services.length || searching ? '' : 'loading'} ${searching ? 'searching' : ''}`,
        ref: servicesList,
        onScroll: handleServicesScroll
    }, (0, _preact.h)("li", {
        class: "ads-li",
        hidden: !services.length || !showAd
    }, showAd && (0, _preact.h)((0, _adDefault.default), {
        key: "ad"
    })), services.length ? (expandedSearchOnce ? services : services.slice(0, 25)).map((s)=>{
        const isServicePage = route.page === 'service';
        const checked = route.value && route.value.split('~').includes(s.number);
        return (0, _preact.h)("li", {
            key: s.number
        }, (0, _preact.h)("a", {
            href: `#/services/${s.number}`,
            class: checked ? 'current' : '',
            onMouseEnter: ()=>previewRoute(s.number),
            onMouseLeave: unpreviewRoute
        }, (0, _preact.h)("b", {
            class: "service-tag"
        }, s.number), " ", s.name), (0, _preact.h)("label", {
            hidden: !isServicePage
        }, (0, _preact.h)("input", {
            type: "checkbox",
            checked: checked,
            onChange: (e)=>{
                const { checked } = e.target;
                let newServices = [];
                if (checked) newServices = route.value.split('~').concat(s.number);
                else newServices = route.value.split('~').filter((service)=>service !== s.number);
                newServices.sort((0, _bus.sortServices));
                setTimeout(()=>{
                    if (newServices.length) location.hash = `/services/${newServices.join('~')}`;
                    else location.hash = '/';
                }, 250);
            }
        })));
    }) : !searching && [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ].map((s, i)=>(0, _preact.h)("li", {
            key: s
        }, (0, _preact.h)("a", {
            href: "#"
        }, (0, _preact.h)("b", {
            class: "service-tag"
        }, "\xA0\xA0\xA0"), (0, _preact.h)("span", {
            class: "placeholder"
        }, "\u2588\u2588\u2588\u2588\u2588", i % 3 == 0 ? "\u2588\u2588\u2588" : '', " \u2588\u2588\u2588", i % 2 == 0 ? "\u2588\u2588\u2588\u2588" : '')))), searching && !!stops.length && stops.map((s)=>(0, _preact.h)("li", {
            key: s.number
        }, (0, _preact.h)("a", {
            href: `#/stops/${s.number}`
        }, (0, _preact.h)("b", {
            class: "stop-tag"
        }, s.number), " ", s.name))), searching && !stops.length && !services.length && (0, _preact.h)("li", {
        class: "nada"
    }, "No results.")), (0, _preact.h)("div", {
        class: "sidebar-ads",
        hidden: !showAd
    }, showAd && (0, _preact.h)((0, _adDefault.default), {
        key: "ad2"
    })))), (0, _preact.h)("div", {
        id: "stop-popover",
        ref: stopPopover,
        class: `popover ${showStopPopover ? 'expand' : ''}`
    }, stopPopoverData && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
        href: "#/",
        onClick: hideStopPopover,
        class: "popover-close"
    }, "\xD7"), (0, _preact.h)("header", null, (0, _preact.h)("h1", {
        onClick: ()=>zoomToStop(stopPopoverData.number)
    }, (0, _preact.h)("b", {
        class: "stop-tag"
    }, stopPopoverData.number), ' ', stopPopoverData.name)), (0, _preact.h)((0, _scrollableContainerDefault.default), {
        class: "popover-scroll"
    }, (0, _preact.h)("h2", null, t('glossary.nServices', {
        count: stopPopoverData.services.length
    }), ' ', "\u2219", ' ', (0, _preact.h)("a", {
        href: `/bus-first-last/#${stopPopoverData.number}`,
        target: "_blank"
    }, t('stop.firstLastBus'), ' ', (0, _preact.h)("img", {
        src: (0, _openNewWindowSvgDefault.default),
        width: "12",
        height: "12",
        alt: "",
        class: "new-window"
    }))), (0, _preact.h)((0, _busServicesArrivalDefault.default), {
        active: showStopPopover,
        map: map,
        showBusesOnMap: route.page !== 'service',
        id: stopPopoverData.number,
        services: stopPopoverData.services
    })), (0, _preact.h)("div", {
        class: "popover-footer"
    }, (0, _preact.h)("div", {
        class: "popover-buttons alt-hide"
    }, (0, _preact.h)("a", {
        href: `/bus-arrival/#${stopPopoverData.number}`,
        target: "_blank",
        onClick: openBusArrival,
        class: "popover-button primary"
    }, t('glossary.busArrivals'), ' ', (0, _preact.h)("img", {
        src: (0, _openNewWindowBlueSvgDefault.default),
        width: "16",
        height: "16",
        alt: ""
    })), stopPopoverData.services.length > 1 && (0, _preact.h)("a", {
        href: `#/stops/${stopPopoverData.number}/routes`,
        class: "popover-button"
    }, t('glossary.passingRoutes'), ' ', (0, _preact.h)("img", {
        src: (0, _passingRoutesBlueSvgDefault.default),
        width: "16",
        height: "16",
        alt: ""
    }))), (0, _preact.h)("div", {
        class: "popover-buttons alt-show-flex"
    }, (0, _preact.h)("button", {
        onClick: ()=>setStartStop(stopPopoverData.number),
        class: "popover-button"
    }, "Set as Start"), (0, _preact.h)("button", {
        onClick: ()=>setEndStop(stopPopoverData.number),
        class: "popover-button"
    }, "Set as End"))))), (0, _preact.h)("div", {
        ref: servicePopover,
        id: "service-popover",
        class: `popover ${showServicePopover ? 'expand' : ''}`,
        key: ``
    }, (0, _preact.h)("a", {
        href: "#/",
        onClick: navBackToStop,
        class: "popover-close"
    }, "\xD7"), servicesData && routeServices.length && (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("header", null, (0, _preact.h)("h1", null, (0, _preact.h)("b", {
        class: "service-tag"
    }, routeServices[0]), servicesData[routeServices[0]].name)), (0, _preact.h)((0, _scrollableContainerDefault.default), {
        class: "popover-scroll",
        scrollToTopKey: `sttk-${routeServices[0]}`
    }, (0, _preact.h)("h2", null, t('glossary.nRoutes', {
        count: servicesData[routeServices[0]].routes.length
    }), ' ', "\u2219", ' ', servicesData[routeServices[0]].routes.map((route)=>t('glossary.nStops', {
            count: route.length
        })).join(" \u2219 "), "\xA0\xA0", (0, _preact.h)("button", {
        type: "button",
        class: "plus",
        onClick: ()=>{
            setExpandSearch(true);
            setExpandedSearchOnce(true);
        },
        title: t('multiRoute.addRoute')
    })), (0, _preact.h)((0, _stopsListJsxDefault.default), {
        routes: servicesData[routeServices[0]].routes,
        stopsData: stopsData,
        onStopClick: zoomToStop,
        onStopClickAgain: _showStopPopover
    }), (0, _preact.h)("div", {
        class: "callout info"
    }, (0, _preact.h)("span", {
        class: "legend-opposite"
    }), " ", t('service.oppositeLegend'))))), (0, _preact.h)("div", {
        id: "between-popover",
        ref: betweenPopover,
        class: `popover ${showBetweenPopover ? 'expand' : ''}`
    }, showBetweenPopover && [
        (0, _preact.h)("a", {
            href: "#/",
            onClick: resetStartEndStops,
            class: "popover-close"
        }, "\xD7"),
        (0, _preact.h)("header", null, (0, _preact.h)("h1", null, (0, _preact.h)("small", null, "Routes between"), (0, _preact.h)("br", null), (0, _preact.h)("b", {
            class: "stop-tag"
        }, showBetweenPopover.startStop.number), " and", ' ', (0, _preact.h)("b", {
            class: "stop-tag"
        }, showBetweenPopover.endStop.number))),
        (0, _preact.h)("div", {
            class: "popover-scroll"
        }, (0, _preact.h)("div", {
            class: "callout warning"
        }, "This is a beta feature. Directions and routes may not be correct."), (0, _preact.h)("h2", null, "Direct routes"), (0, _preact.h)((0, _betweenRoutesDefault.default), {
            results: showBetweenPopover.results[0],
            onClickRoute: (e, result)=>renderBetweenRoute({
                    e,
                    startStop: showBetweenPopover.startStop,
                    endStop: showBetweenPopover.endStop,
                    result
                })
        }), (0, _preact.h)("h2", null, "Alternative routes"), (0, _preact.h)("h3", null, "Nearby arrival stop: ", showBetweenPopover.nearestEndStop.number, " (", showBetweenPopover.endWalkMins, "-min walk)"), (0, _preact.h)((0, _betweenRoutesDefault.default), {
            results: showBetweenPopover.results[1],
            nearbyEnd: true,
            onClickRoute: (e, result)=>renderBetweenRoute({
                    e,
                    startStop: showBetweenPopover.startStop,
                    endStop: showBetweenPopover.endStop,
                    result
                })
        }), (0, _preact.h)("h3", null, "Nearby departure stop:", ' ', showBetweenPopover.nearestStartStop.number, " (", showBetweenPopover.startWalkMins, "-min walk)"), (0, _preact.h)((0, _betweenRoutesDefault.default), {
            results: showBetweenPopover.results[2],
            nearbyStart: true,
            onClickRoute: (e, result)=>renderBetweenRoute({
                    e,
                    startStop: showBetweenPopover.startStop,
                    endStop: showBetweenPopover.endStop,
                    result
                })
        }), (0, _preact.h)("h3", null, "Nearby departure & arrival stops:", ' ', showBetweenPopover.nearestStartStop.number, " -", ' ', showBetweenPopover.nearestEndStop.number), (0, _preact.h)((0, _betweenRoutesDefault.default), {
            results: showBetweenPopover.results[3],
            nearbyStart: true,
            nearbyEnd: true,
            onClickRoute: (e, result)=>renderBetweenRoute({
                    e,
                    startStop: showBetweenPopover.startStop,
                    endStop: showBetweenPopover.endStop,
                    result
                })
        }))
    ]), (0, _preact.h)("div", {
        id: "arrivals-popover",
        class: `popover ${showArrivalsPopover ? 'expand' : ''}`
    }, showArrivalsPopover && [
        (0, _preact.h)("a", {
            href: "#/",
            onClick: closeBusArrival,
            class: "popover-close"
        }, "\xD7"),
        (0, _preact.h)("a", {
            href: `/bus-arrival/#${showArrivalsPopover.number}`,
            target: "_blank",
            onClick: (e)=>{
                openBusArrival(e, true);
                closeBusArrival(e);
            },
            class: "popover-popout popover-close"
        }, "Pop out", ' ', (0, _preact.h)("img", {
            src: (0, _openNewWindowSvgDefault.default),
            width: "16",
            height: "16",
            alt: ""
        })),
        (0, _preact.h)("div", {
            class: "popover-scroll"
        }, (0, _preact.h)("iframe", {
            src: showArrivalsPopover.webviewURL
        }))
    ]));
};
(0, _preact.render)((0, _preact.h)(App, null), document.getElementById('app'));
if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    navigator.serviceWorker.register(require("96a5551e0cc15851"));
});
if (matchMedia('(display-mode: standalone)').matches || 'standalone' in navigator) gtag('event', 'pwa_load', {
    event_category: 'PWA',
    event_label: 'standalone',
    value: true,
    non_interaction: true
});
if (window.navigator.standalone) {
    document.body.classList.add('standalone');
    // Refresh map size when dismissing software keyboard
    // https://stackoverflow.com/a/19464029/20838
    document.addEventListener('focusout', ()=>{
        if (_map) _map.resize();
    });
    // Enable CSS active states
    document.addEventListener('touchstart', ()=>{}, false);
}
const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') !== -1;
if (isSafari && !window.navigator.standalone) setTimeout(function() {
    const ratio = window.devicePixelRatio;
    const canvas = document.createElement('canvas');
    const w = canvas.width = window.screen.width * ratio;
    const h = canvas.height = window.screen.height * ratio;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#F9F5ED';
    ctx.fillRect(0, 0, w, h);
    const icon = new Image();
    icon.onload = ()=>{
        const aspectRatio = icon.width / icon.height;
        icon.width = w / 2;
        icon.height = w / 2 / aspectRatio;
        ctx.drawImage(icon, (w - icon.width) / 2, (h - icon.height) / 2, icon.width, icon.height);
        document.head.insertAdjacentHTML('beforeend', `<link rel="apple-touch-startup-image" href="${canvas.toDataURL()}">`);
    };
    icon.src = (0, _iconSvgDefault.default);
}, 5000);

},{"./i18n":"h6hrD","./error-tracking":"PbMFz","preact":"fvkQC","preact/hooks":"2EbRR","maplibre-gl":"lyGpb","@mapbox/polyline":"jmhTH","fuse.js":"20V6w","just-intersect":"j3enm","cheap-ruler":"esqZH","@mapbox/mapbox-gl-language":"lROcj","react-i18next":"3s9bS","pmtiles":"cbZxG","./map-style":"iqBhG","./utils/specialID":"lXpo4","./utils/bus":"4E495","./utils/fetchCache":"kNdlE","./utils/getRoute":"kYEZr","./utils/getDistance":"fAMC2","./utils/getWalkingMinutes":"tXXxs","./utils/usePrevious":"ixjNm","./ad":"hPAiX","./components/About":"6rBCO","./components/BusServicesArrival":"8ZuIH","./components/GeolocateControl":"kT5y8","./components/BetweenRoutes":"6sgRh","./components/ScrollableContainer":"M6shC","./components/StopsList.jsx":"cMevO","./images/stop.png":"7zRGY","./images/stop-end.png":"kWviM","./images/mrt-station.png":"7hVEL","./images/lrt-station.png":"fNIWy","./images/open-new-window.svg":"lcYP5","./images/open-new-window-blue.svg":"ki0rJ","./images/passing-routes-blue.svg":"e5BIP","../icons/icon.svg":"hdUY8","./images/bus-tiny.png":"50ryH","96a5551e0cc15851":"gumpS","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jmhTH":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
 *
 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
 *
 * @module polyline
 */ var polyline = {};
function py2_round(value) {
    // Google's polyline algorithm uses the same rounding strategy as Python 2, which is different from JS for negative values
    return Math.floor(Math.abs(value) + 0.5) * (value >= 0 ? 1 : -1);
}
function encode(current, previous, factor) {
    current = py2_round(current * factor);
    previous = py2_round(previous * factor);
    var coordinate = (current - previous) * 2;
    if (coordinate < 0) coordinate = -coordinate - 1;
    var output = '';
    while(coordinate >= 0x20){
        output += String.fromCharCode((0x20 | coordinate & 0x1f) + 63);
        coordinate /= 32;
    }
    output += String.fromCharCode((coordinate | 0) + 63);
    return output;
}
/**
 * Decodes to a [latitude, longitude] coordinates array.
 *
 * This is adapted from the implementation in Project-OSRM.
 *
 * @param {String} str
 * @param {Number} precision
 * @returns {Array}
 *
 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
 */ polyline.decode = function(str, precision) {
    var index = 0, lat = 0, lng = 0, coordinates = [], shift = 0, result = 0, byte = null, latitude_change, longitude_change, factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while(index < str.length){
        // Reset shift, result, and byte
        byte = null;
        shift = 1;
        result = 0;
        do {
            byte = str.charCodeAt(index++) - 63;
            result += (byte & 0x1f) * shift;
            shift *= 32;
        }while (byte >= 0x20);
        latitude_change = result & 1 ? (-result - 1) / 2 : result / 2;
        shift = 1;
        result = 0;
        do {
            byte = str.charCodeAt(index++) - 63;
            result += (byte & 0x1f) * shift;
            shift *= 32;
        }while (byte >= 0x20);
        longitude_change = result & 1 ? (-result - 1) / 2 : result / 2;
        lat += latitude_change;
        lng += longitude_change;
        coordinates.push([
            lat / factor,
            lng / factor
        ]);
    }
    return coordinates;
};
/**
 * Encodes the given [latitude, longitude] coordinates array.
 *
 * @param {Array.<Array.<Number>>} coordinates
 * @param {Number} precision
 * @returns {String}
 */ polyline.encode = function(coordinates, precision) {
    if (!coordinates.length) return '';
    var factor = Math.pow(10, Number.isInteger(precision) ? precision : 5), output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
    for(var i = 1; i < coordinates.length; i++){
        var a = coordinates[i], b = coordinates[i - 1];
        output += encode(a[0], b[0], factor);
        output += encode(a[1], b[1], factor);
    }
    return output;
};
function flipped(coords) {
    var flipped = [];
    for(var i = 0; i < coords.length; i++){
        var coord = coords[i].slice();
        flipped.push([
            coord[1],
            coord[0]
        ]);
    }
    return flipped;
}
/**
 * Encodes a GeoJSON LineString feature/geometry.
 *
 * @param {Object} geojson
 * @param {Number} precision
 * @returns {String}
 */ polyline.fromGeoJSON = function(geojson, precision) {
    if (geojson && geojson.type === 'Feature') geojson = geojson.geometry;
    if (!geojson || geojson.type !== 'LineString') throw new Error('Input must be a GeoJSON LineString');
    return polyline.encode(flipped(geojson.coordinates), precision);
};
/**
 * Decodes to a GeoJSON LineString geometry.
 *
 * @param {String} str
 * @param {Number} precision
 * @returns {Object}
 */ polyline.toGeoJSON = function(str, precision) {
    var coords = polyline.decode(str, precision);
    return {
        type: 'LineString',
        coordinates: flipped(coords)
    };
};
if (module.exports) module.exports = polyline;

},{}],"20V6w":[function(require,module,exports,__globalThis) {
/**
 * Fuse.js v7.1.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2025 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Fuse);
function isArray(value) {
    return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const INFINITY = 1 / 0;
function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
function toString(value) {
    return value == null ? '' : baseToString(value);
}
function isString(value) {
    return typeof value === 'string';
}
function isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
}
function isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function isObjectLike(value) {
    return isObject(value) && value !== null;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const hasOwn = Object.prototype.hasOwnProperty;
class KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if (isString(key) || isArray(key)) {
        src = key;
        path = createKeyPath(key);
        id = createKeyId(key);
    } else {
        if (!hasOwn.call(key, 'name')) throw new Error(MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if (hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = createKeyPath(name);
        id = createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path,
        id,
        weight,
        src,
        getFn
    };
}
function createKeyPath(key) {
    return isArray(key) ? key : key.split('.');
}
function createKeyId(key) {
    return isArray(key) ? key.join('.') : key;
}
function get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
            else if (isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When `true`, the algorithm will ignore diacritics (accents) in comparisons
    ignoreDiacritics: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var Config = {
    ...BasicOptions,
    ...MatchOptions,
    ...FuzzyOptions,
    ...AdvancedOptions
};
const SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match(SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class FuseIndex {
    constructor({ getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}){
        this.norm = norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if (isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!isDefined(doc) || isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!isDefined(value)) return;
            if (isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex, value } = stack.pop();
                    if (!isDefined(value)) continue;
                    if (isString(value) && !isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if (isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if (isString(value) && !isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function createIndex(keys, docs, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
    const myIndex = new FuseIndex({
        getFn,
        fieldNormWeight
    });
    myIndex.setKeys(keys.map(createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function parseIndex(data, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
    const { keys, records } = data;
    const myIndex = new FuseIndex({
        getFn,
        fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function computeScore$1(pattern, { errors = 0, currentLocation = 0, expectedLocation = 0, distance = Config.distance, ignoreLocation = Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const MAX_BITS = 32;
function search(text, pattern, patternAlphabet, { location = Config.location, distance = Config.distance, threshold = Config.threshold, findAllMatches = Config.findAllMatches, minMatchCharLength = Config.minMatchCharLength, includeMatches = Config.includeMatches, ignoreLocation = Config.ignoreLocation } = {}) {
    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation,
            distance,
            ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation,
                distance,
                ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = computeScore$1(pattern, {
                    errors: i,
                    currentLocation,
                    expectedLocation,
                    distance,
                    ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation,
            distance,
            ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
const stripDiacritics = String.prototype.normalize ? (str)=>str.normalize('NFD').replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, '') : (str)=>str;
class BitapSearch {
    constructor(pattern, { location = Config.location, threshold = Config.threshold, distance = Config.distance, includeMatches = Config.includeMatches, findAllMatches = Config.findAllMatches, minMatchCharLength = Config.minMatchCharLength, isCaseSensitive = Config.isCaseSensitive, ignoreDiacritics = Config.ignoreDiacritics, ignoreLocation = Config.ignoreLocation } = {}){
        this.options = {
            location,
            threshold,
            distance,
            includeMatches,
            findAllMatches,
            minMatchCharLength,
            isCaseSensitive,
            ignoreDiacritics,
            ignoreLocation
        };
        pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        pattern = ignoreDiacritics ? stripDiacritics(pattern) : pattern;
        this.pattern = pattern;
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern,
                alphabet: createPatternAlphabet(pattern),
                startIndex
            });
        };
        const len = this.pattern.length;
        if (len > MAX_BITS) {
            let i = 0;
            const remainder = len % MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, MAX_BITS), i);
                i += MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive, ignoreDiacritics, includeMatches } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        text = ignoreDiacritics ? stripDiacritics(text) : text;
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location, distance, threshold, findAllMatches, minMatchCharLength, ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern, alphabet, startIndex })=>{
            const { isMatch, score, indices } = search(text, pattern, alphabet, {
                location: location + startIndex,
                distance,
                threshold,
                findAllMatches,
                minMatchCharLength,
                includeMatches,
                ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class ExactMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class InverseExactMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class PrefixExactMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class InversePrefixExactMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class SuffixExactMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class InverseSuffixExactMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class FuzzyMatch extends BaseMatch {
    constructor(pattern, { location = Config.location, threshold = Config.threshold, distance = Config.distance, includeMatches = Config.includeMatches, findAllMatches = Config.findAllMatches, minMatchCharLength = Config.minMatchCharLength, isCaseSensitive = Config.isCaseSensitive, ignoreDiacritics = Config.ignoreDiacritics, ignoreLocation = Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new BitapSearch(pattern, {
            location,
            threshold,
            distance,
            includeMatches,
            findAllMatches,
            minMatchCharLength,
            isCaseSensitive,
            ignoreDiacritics,
            ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class IncludeMatch extends BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch,
            score: isMatch ? 0 : 1,
            indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const searchers = [
    ExactMatch,
    IncludeMatch,
    PrefixExactMatch,
    InversePrefixExactMatch,
    InverseSuffixExactMatch,
    SuffixExactMatch,
    InverseExactMatch,
    FuzzyMatch
];
const searchersLen = searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
    return pattern.split(OR_TOKEN).map((item)=>{
        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < searchersLen){
                const searcher = searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < searchersLen){
                const searcher = searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([
    FuzzyMatch.type,
    IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
    constructor(pattern, { isCaseSensitive = Config.isCaseSensitive, ignoreDiacritics = Config.ignoreDiacritics, includeMatches = Config.includeMatches, minMatchCharLength = Config.minMatchCharLength, ignoreLocation = Config.ignoreLocation, findAllMatches = Config.findAllMatches, location = Config.location, threshold = Config.threshold, distance = Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive,
            ignoreDiacritics,
            includeMatches,
            minMatchCharLength,
            findAllMatches,
            ignoreLocation,
            location,
            threshold,
            distance
        };
        pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        pattern = ignoreDiacritics ? stripDiacritics(pattern) : pattern;
        this.pattern = pattern;
        this.query = parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches, isCaseSensitive, ignoreDiacritics } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        text = ignoreDiacritics ? stripDiacritics(text) : text;
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch, indices, score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if (MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const registeredSearchers = [];
function register(...args) {
    registeredSearchers.push(...args);
}
function createSearcher(pattern, options) {
    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
        let searcherClass = registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new BitapSearch(pattern, options);
}
const LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
const isPath = (query)=>!!query[KeyType.PATH];
const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
const convertToExplicit = (query)=>({
        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options, { auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = isPath(query);
        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
        if (isLeaf(query)) {
            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: createKeyId(key),
                pattern
            };
            if (auto) obj.searcher = createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if (isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!isExpression(query)) query = convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function computeScore(results, { ignoreFieldNorm = Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key, norm, score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!isDefined(match.indices) || !match.indices.length) return;
        const { indices, value } = match;
        let obj = {
            indices,
            value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function transformScore(result, data) {
    data.score = result.score;
}
function format(results, docs, { includeMatches = Config.includeMatches, includeScore = Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push(transformMatches);
    if (includeScore) transformers.push(transformScore);
    return results.map((result)=>{
        const { idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class Fuse {
    constructor(docs, options = {}, index){
        this.options = {
            ...Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
        this._myIndex = index || createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit = -1 } = {}) {
        const { includeMatches, includeScore, shouldSort, sortFn, ignoreFieldNorm } = this.options;
        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        computeScore(results, {
            ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return format(results, this._docs, {
            includeMatches,
            includeScore
        });
    }
    _searchStringList(query) {
        const searcher = createSearcher(query, this.options);
        const { records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!isDefined(text)) return;
            const { isMatch, score, indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx,
                matches: [
                    {
                        score,
                        value: text,
                        norm,
                        indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId, searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher
                });
                if (matches && matches.length) return [
                    {
                        idx,
                        item,
                        matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if (isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx,
                            item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = createSearcher(query, this.options);
        const { keys, records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key,
                    value: item[keyIndex],
                    searcher
                }));
            });
            if (matches.length) results.push({
                idx,
                item,
                matches
            });
        });
        return results;
    }
    _findMatches({ key, value, searcher }) {
        if (!isDefined(value)) return [];
        let matches = [];
        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!isDefined(text)) return;
            const { isMatch, score, indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score,
                key,
                value: text,
                idx,
                norm,
                indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch, score, indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score,
                key,
                value: text,
                norm,
                indices
            });
        }
        return matches;
    }
}
Fuse.version = '7.1.0';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;
Fuse.parseQuery = parse;
register(ExtendedSearch);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ftQX7":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"j3enm":[function(require,module,exports,__globalThis) {
module.exports = intersect;
/*
  intersect([1, 2, 5, 6], [2, 3, 5, 6]); // [2, 5, 6]
  intersect([1, 2, 2, 4, 5], [3, 2, 2, 5, 7]); // [2, 5]
*/ function intersect(arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) throw new Error('expected both arguments to be arrays');
    var result = [];
    var set = convertArrayToSet(arr2);
    var memo = {};
    for(var i = 0; i < arr1.length; i++){
        var item = arr1[i];
        if (set.hasOwnProperty(item) && !memo.hasOwnProperty(item)) {
            result.push(item);
            memo[item] = true;
        }
    }
    return result;
}
function convertArrayToSet(arr) {
    var output = {};
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        if (!output.hasOwnProperty(item)) output[item] = true;
    }
    return output;
}

},{}],"esqZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const factors = {
    kilometers: 1,
    miles: 1000 / 1609.344,
    nauticalmiles: 1000 / 1852,
    meters: 1000,
    metres: 1000,
    yards: 1000 / 0.9144,
    feet: 1000 / 0.3048,
    inches: 1000 / 0.0254
};
// Values that define WGS84 ellipsoid model of the Earth
const RE = 6378.137; // equatorial radius
const FE = 1 / 298.257223563; // flattening
const E2 = FE * (2 - FE);
const RAD = Math.PI / 180;
class CheapRuler {
    /**
     * Creates a ruler object from tile coordinates (y and z).
     *
     * @param {number} y
     * @param {number} z
     * @param {keyof typeof factors} [units='kilometers']
     * @returns {CheapRuler}
     * @example
     * const ruler = cheapRuler.fromTile(1567, 12);
     * //=ruler
     */ static fromTile(y, z, units) {
        const n = Math.PI * (1 - 2 * (y + 0.5) / Math.pow(2, z));
        const lat = Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))) / RAD;
        return new CheapRuler(lat, units);
    }
    /**
     * Multipliers for converting between units.
     *
     * @example
     * // convert 50 meters to yards
     * 50 * CheapRuler.units.yards / CheapRuler.units.meters;
     */ static get units() {
        return factors;
    }
    /**
     * Creates a ruler instance for very fast approximations to common geodesic measurements around a certain latitude.
     *
     * @param {number} lat latitude
     * @param {keyof typeof factors} [units='kilometers']
     * @example
     * const ruler = cheapRuler(35.05, 'miles');
     * //=ruler
     */ constructor(lat, units){
        if (lat === undefined) throw new Error('No latitude given.');
        if (units && !factors[units]) throw new Error(`Unknown unit ${units}. Use one of: ${Object.keys(factors).join(', ')}`);
        // Curvature formulas from https://en.wikipedia.org/wiki/Earth_radius#Meridional
        const m = RAD * RE * (units ? factors[units] : 1);
        const coslat = Math.cos(lat * RAD);
        const w2 = 1 / (1 - E2 * (1 - coslat * coslat));
        const w = Math.sqrt(w2);
        // multipliers for converting longitude and latitude degrees into distance
        this.kx = m * w * coslat; // based on normal radius of curvature
        this.ky = m * w * w2 * (1 - E2); // based on meridonal radius of curvature
    }
    /**
     * Given two points of the form [longitude, latitude], returns the distance.
     *
     * @param {[number, number]} a point [longitude, latitude]
     * @param {[number, number]} b point [longitude, latitude]
     * @returns {number} distance
     * @example
     * const distance = ruler.distance([30.5, 50.5], [30.51, 50.49]);
     * //=distance
     */ distance(a, b) {
        const dx = wrap(a[0] - b[0]) * this.kx;
        const dy = (a[1] - b[1]) * this.ky;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
     * Returns the bearing between two points in angles.
     *
     * @param {[number, number]} a point [longitude, latitude]
     * @param {[number, number]} b point [longitude, latitude]
     * @returns {number} bearing
     * @example
     * const bearing = ruler.bearing([30.5, 50.5], [30.51, 50.49]);
     * //=bearing
     */ bearing(a, b) {
        const dx = wrap(b[0] - a[0]) * this.kx;
        const dy = (b[1] - a[1]) * this.ky;
        return Math.atan2(dx, dy) / RAD;
    }
    /**
     * Returns a new point given distance and bearing from the starting point.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {number} dist distance
     * @param {number} bearing
     * @returns {[number, number]} point [longitude, latitude]
     * @example
     * const point = ruler.destination([30.5, 50.5], 0.1, 90);
     * //=point
     */ destination(p, dist, bearing) {
        const a = bearing * RAD;
        return this.offset(p, Math.sin(a) * dist, Math.cos(a) * dist);
    }
    /**
     * Returns a new point given easting and northing offsets (in ruler units) from the starting point.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {number} dx easting
     * @param {number} dy northing
     * @returns {[number, number]} point [longitude, latitude]
     * @example
     * const point = ruler.offset([30.5, 50.5], 10, 10);
     * //=point
     */ offset(p, dx, dy) {
        return [
            p[0] + dx / this.kx,
            p[1] + dy / this.ky
        ];
    }
    /**
     * Given a line (an array of points), returns the total line distance.
     *
     * @param {[number, number][]} points [longitude, latitude]
     * @returns {number} total line distance
     * @example
     * const length = ruler.lineDistance([
     *     [-67.031, 50.458], [-67.031, 50.534],
     *     [-66.929, 50.534], [-66.929, 50.458]
     * ]);
     * //=length
     */ lineDistance(points) {
        let total = 0;
        for(let i = 0; i < points.length - 1; i++)total += this.distance(points[i], points[i + 1]);
        return total;
    }
    /**
     * Given a polygon (an array of rings, where each ring is an array of points), returns the area.
     *
     * @param {[number, number][][]} polygon
     * @returns {number} area value in the specified units (square kilometers by default)
     * @example
     * const area = ruler.area([[
     *     [-67.031, 50.458], [-67.031, 50.534], [-66.929, 50.534],
     *     [-66.929, 50.458], [-67.031, 50.458]
     * ]]);
     * //=area
     */ area(polygon) {
        let sum = 0;
        for(let i = 0; i < polygon.length; i++){
            const ring = polygon[i];
            for(let j = 0, len = ring.length, k = len - 1; j < len; k = j++)sum += wrap(ring[j][0] - ring[k][0]) * (ring[j][1] + ring[k][1]) * (i ? -1 : 1);
        }
        return Math.abs(sum) / 2 * this.kx * this.ky;
    }
    /**
     * Returns the point at a specified distance along the line.
     *
     * @param {[number, number][]} line
     * @param {number} dist distance
     * @returns {[number, number]} point [longitude, latitude]
     * @example
     * const point = ruler.along(line, 2.5);
     * //=point
     */ along(line, dist) {
        let sum = 0;
        if (dist <= 0) return line[0];
        for(let i = 0; i < line.length - 1; i++){
            const p0 = line[i];
            const p1 = line[i + 1];
            const d = this.distance(p0, p1);
            sum += d;
            if (sum > dist) return interpolate(p0, p1, (dist - (sum - d)) / d);
        }
        return line[line.length - 1];
    }
    /**
     * Returns the distance from a point `p` to a line segment `a` to `b`.
     *
     * @pointToSegmentDistance
     * @param {[number, number]} p point [longitude, latitude]
     * @param {[number, number]} a segment point 1 [longitude, latitude]
     * @param {[number, number]} b segment point 2 [longitude, latitude]
     * @returns {number} distance
     * @example
     * const distance = ruler.pointToSegmentDistance([-67.04, 50.5], [-67.05, 50.57], [-67.03, 50.54]);
     * //=distance
     */ pointToSegmentDistance(p, a, b) {
        let [x, y] = a;
        let dx = wrap(b[0] - x) * this.kx;
        let dy = (b[1] - y) * this.ky;
        if (dx !== 0 || dy !== 0) {
            const t = (wrap(p[0] - x) * this.kx * dx + (p[1] - y) * this.ky * dy) / (dx * dx + dy * dy);
            if (t > 1) {
                x = b[0];
                y = b[1];
            } else if (t > 0) {
                x += dx / this.kx * t;
                y += dy / this.ky * t;
            }
        }
        dx = wrap(p[0] - x) * this.kx;
        dy = (p[1] - y) * this.ky;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
     * Returns an object of the form {point, index, t}, where point is closest point on the line
     * from the given point, index is the start index of the segment with the closest point,
     * and t is a parameter from 0 to 1 that indicates where the closest point is on that segment.
     *
     * @param {[number, number][]} line
     * @param {[number, number]} p point [longitude, latitude]
     * @returns {{point: [number, number], index: number, t: number}} {point, index, t}
     * @example
     * const point = ruler.pointOnLine(line, [-67.04, 50.5]).point;
     * //=point
     */ pointOnLine(line, p) {
        let minDist = Infinity;
        let minX = line[0][0];
        let minY = line[0][1];
        let minI = 0;
        let minT = 0;
        for(let i = 0; i < line.length - 1; i++){
            let x = line[i][0];
            let y = line[i][1];
            let dx = wrap(line[i + 1][0] - x) * this.kx;
            let dy = (line[i + 1][1] - y) * this.ky;
            let t = 0;
            if (dx !== 0 || dy !== 0) {
                t = (wrap(p[0] - x) * this.kx * dx + (p[1] - y) * this.ky * dy) / (dx * dx + dy * dy);
                if (t > 1) {
                    x = line[i + 1][0];
                    y = line[i + 1][1];
                } else if (t > 0) {
                    x += dx / this.kx * t;
                    y += dy / this.ky * t;
                }
            }
            dx = wrap(p[0] - x) * this.kx;
            dy = (p[1] - y) * this.ky;
            const sqDist = dx * dx + dy * dy;
            if (sqDist < minDist) {
                minDist = sqDist;
                minX = x;
                minY = y;
                minI = i;
                minT = t;
            }
        }
        return {
            point: [
                minX,
                minY
            ],
            index: minI,
            t: Math.max(0, Math.min(1, minT))
        };
    }
    /**
     * Returns a part of the given line between the start and the stop points (or their closest points on the line).
     *
     * @param {[number, number]} start point [longitude, latitude]
     * @param {[number, number]} stop point [longitude, latitude]
     * @param {[number, number][]} line
     * @returns {[number, number][]} line part of a line
     * @example
     * const line2 = ruler.lineSlice([-67.04, 50.5], [-67.05, 50.56], line1);
     * //=line2
     */ lineSlice(start, stop, line) {
        let p1 = this.pointOnLine(line, start);
        let p2 = this.pointOnLine(line, stop);
        if (p1.index > p2.index || p1.index === p2.index && p1.t > p2.t) {
            const tmp = p1;
            p1 = p2;
            p2 = tmp;
        }
        const slice = [
            p1.point
        ];
        const l = p1.index + 1;
        const r = p2.index;
        if (!equals(line[l], slice[0]) && l <= r) slice.push(line[l]);
        for(let i = l + 1; i <= r; i++)slice.push(line[i]);
        if (!equals(line[r], p2.point)) slice.push(p2.point);
        return slice;
    }
    /**
     * Returns a part of the given line between the start and the stop points indicated by distance along the line.
     *
     * @param {number} start start distance
     * @param {number} stop stop distance
     * @param {[number, number][]} line
     * @returns {[number, number][]} part of a line
     * @example
     * const line2 = ruler.lineSliceAlong(10, 20, line1);
     * //=line2
     */ lineSliceAlong(start, stop, line) {
        let sum = 0;
        const slice = [];
        for(let i = 0; i < line.length - 1; i++){
            const p0 = line[i];
            const p1 = line[i + 1];
            const d = this.distance(p0, p1);
            sum += d;
            if (sum > start && slice.length === 0) slice.push(interpolate(p0, p1, (start - (sum - d)) / d));
            if (sum >= stop) {
                slice.push(interpolate(p0, p1, (stop - (sum - d)) / d));
                return slice;
            }
            if (sum > start) slice.push(p1);
        }
        return slice;
    }
    /**
     * Given a point, returns a bounding box object ([w, s, e, n]) created from the given point buffered by a given distance.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {number} buffer
     * @returns {[number, number, number, number]} bbox ([w, s, e, n])
     * @example
     * const bbox = ruler.bufferPoint([30.5, 50.5], 0.01);
     * //=bbox
     */ bufferPoint(p, buffer) {
        const v = buffer / this.ky;
        const h = buffer / this.kx;
        return [
            p[0] - h,
            p[1] - v,
            p[0] + h,
            p[1] + v
        ];
    }
    /**
     * Given a bounding box, returns the box buffered by a given distance.
     *
     * @param {[number, number, number, number]} bbox ([w, s, e, n])
     * @param {number} buffer
     * @returns {[number, number, number, number]} bbox ([w, s, e, n])
     * @example
     * const bbox = ruler.bufferBBox([30.5, 50.5, 31, 51], 0.2);
     * //=bbox
     */ bufferBBox(bbox, buffer) {
        const v = buffer / this.ky;
        const h = buffer / this.kx;
        return [
            bbox[0] - h,
            bbox[1] - v,
            bbox[2] + h,
            bbox[3] + v
        ];
    }
    /**
     * Returns true if the given point is inside in the given bounding box, otherwise false.
     *
     * @param {[number, number]} p point [longitude, latitude]
     * @param {[number, number, number, number]} bbox ([w, s, e, n])
     * @returns {boolean}
     * @example
     * const inside = ruler.insideBBox([30.5, 50.5], [30, 50, 31, 51]);
     * //=inside
     */ insideBBox(p, bbox) {
        return wrap(p[0] - bbox[0]) >= 0 && wrap(p[0] - bbox[2]) <= 0 && p[1] >= bbox[1] && p[1] <= bbox[3];
    }
}
exports.default = CheapRuler;
/**
 * @param {[number, number]} a
 * @param {[number, number]} b
 */ function equals(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
/**
 * @param {[number, number]} a
 * @param {[number, number]} b
 * @param {number} t
 * @returns {[number, number]}
 */ function interpolate(a, b, t) {
    const dx = wrap(b[0] - a[0]);
    const dy = b[1] - a[1];
    return [
        a[0] + dx * t,
        a[1] + dy * t
    ];
}
/**
 * normalize a degree value into [-180..180] range
 * @param {number} deg
 */ function wrap(deg) {
    while(deg < -180)deg += 360;
    while(deg > 180)deg -= 360;
    return deg;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lROcj":[function(require,module,exports,__globalThis) {
/**
 * Create a new [Mapbox GL JS plugin](https://www.mapbox.com/blog/build-mapbox-gl-js-plugins/) that
 * modifies the layers of the map style to use the `text-field` that matches the browser language.
 * As of Mapbox GL Language v1.0.0, this plugin no longer supports token values (e.g. `{name}`). v1.0+ expects the `text-field`
 * property of a style to use an [expression](https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/) of the form `['get', 'name_en']` or `['get', 'name']`; these expressions can be nested. Note that `get` expressions used as inputs to other expressions may not be handled by this plugin. For example:
 * ```
 * ["match",
 *   ["get", "name"],
 *   "California",
 *   "Golden State",
 *   ["coalesce",
 *     ["get", "name_en"],
 *     ["get", "name"]
 *   ]
 * ]
 * ```
 * Only styles based on [Mapbox v8 styles](https://docs.mapbox.com/help/troubleshooting/streets-v8-migration-guide/) are supported.
 *
 * @constructor
 * @param {object} options - Options to configure the plugin.
 * @param {string[]} [options.supportedLanguages] - List of supported languages
 * @param {Function} [options.languageTransform] - Custom style transformation to apply
 * @param {RegExp} [options.languageField=/^name_/] - RegExp to match if a text-field is a language field
 * @param {Function} [options.getLanguageField] - Given a language choose the field in the vector tiles
 * @param {string} [options.languageSource] - Name of the source that contains the different languages.
 * @param {string} [options.defaultLanguage] - Name of the default language to initialize style after loading.
 * @param {string[]} [options.excludedLayerIds] - Name of the layers that should be excluded from translation.
 */ function MapboxLanguage(options) {
    options = Object.assign({}, options);
    if (!(this instanceof MapboxLanguage)) throw new Error('MapboxLanguage needs to be called with the new keyword');
    this.setLanguage = this.setLanguage.bind(this);
    this._initialStyleUpdate = this._initialStyleUpdate.bind(this);
    this._defaultLanguage = options.defaultLanguage;
    this._isLanguageField = options.languageField || /^name_/;
    this._getLanguageField = options.getLanguageField || function nameField(language) {
        return language === 'mul' ? 'name' : `name_${language}`;
    };
    this._languageSource = options.languageSource || null;
    this._languageTransform = options.languageTransform;
    this._excludedLayerIds = options.excludedLayerIds || [];
    this.supportedLanguages = options.supportedLanguages || [
        'ar',
        'de',
        'en',
        'es',
        'fr',
        'it',
        'ja',
        'ko',
        'mul',
        'pt',
        'ru',
        'vi',
        'zh-Hans',
        'zh-Hant'
    ];
}
const isTokenField = /^\{name/;
function isFlatExpressionField(isLangField, property) {
    const isGetExpression = Array.isArray(property) && property[0] === 'get';
    if (isGetExpression && isTokenField.test(property[1])) console.warn('This plugin no longer supports the use of token syntax (e.g. {name}). Please use a get expression. See https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/ for more details.');
    return isGetExpression && isLangField.test(property[1]);
}
function adaptNestedExpressionField(isLangField, property, languageFieldName) {
    if (Array.isArray(property)) {
        for(let i = 1; i < property.length; i++)if (Array.isArray(property[i])) {
            if (isFlatExpressionField(isLangField, property[i])) property[i][1] = languageFieldName;
            adaptNestedExpressionField(isLangField, property[i], languageFieldName);
        }
    }
}
function adaptPropertyLanguage(isLangField, property, languageFieldName) {
    if (isFlatExpressionField(isLangField, property)) property[1] = languageFieldName;
    adaptNestedExpressionField(isLangField, property, languageFieldName);
    // handle special case of bare ['get', 'name'] expression by wrapping it in a coalesce statement
    if (property[0] === 'get' && property[1] === 'name') {
        const defaultProp = property.slice();
        const adaptedProp = [
            'get',
            languageFieldName
        ];
        property = [
            'coalesce',
            adaptedProp,
            defaultProp
        ];
    }
    return property;
}
function changeLayerTextProperty(isLangField, layer, languageFieldName, excludedLayerIds) {
    if (layer.layout && layer.layout['text-field'] && excludedLayerIds.indexOf(layer.id) === -1) return Object.assign({}, layer, {
        layout: Object.assign({}, layer.layout, {
            'text-field': adaptPropertyLanguage(isLangField, layer.layout['text-field'], languageFieldName)
        })
    });
    return layer;
}
function findStreetsSource(style) {
    const sources = Object.keys(style.sources).filter((sourceName)=>{
        const url = style.sources[sourceName].url;
        // the source URL can reference the source version or the style version
        // this check and the error forces users to migrate to styles using source version 8
        return url && url.indexOf('mapbox.mapbox-streets-v8') > -1 || /mapbox-streets-v[1-9][1-9]/.test(url);
    });
    if (!sources.length) throw new Error('If using MapboxLanguage with a Mapbox style, the style must be based on vector tile version 8, e.g. "streets-v11"');
    return sources[0];
}
/**
 * Explicitly change the language for a style.
 * @param {object} style - Mapbox GL style to modify
 * @param {string} language - The language iso code
 * @returns {object} the modified style
 */ MapboxLanguage.prototype.setLanguage = function(style, language) {
    if (this.supportedLanguages.indexOf(language) < 0) throw new Error(`Language ${language} is not supported`);
    const streetsSource = this._languageSource || findStreetsSource(style);
    if (!streetsSource) return style;
    const field = this._getLanguageField(language);
    const isLangField = this._isLanguageField;
    const excludedLayerIds = this._excludedLayerIds;
    const changedLayers = style.layers.map((layer)=>{
        if (layer.source === streetsSource) return changeLayerTextProperty(isLangField, layer, field, excludedLayerIds);
        return layer;
    });
    const languageStyle = Object.assign({}, style, {
        layers: changedLayers
    });
    return this._languageTransform ? this._languageTransform(languageStyle, language) : languageStyle;
};
MapboxLanguage.prototype._initialStyleUpdate = function() {
    const style = this._map.getStyle();
    const language = this._defaultLanguage || browserLanguage(this.supportedLanguages);
    this._map.setStyle(this.setLanguage(style, language));
};
function browserLanguage(supportedLanguages) {
    const language = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
    const parts = language && language.split('-');
    let languageCode = language;
    if (parts.length > 1) languageCode = parts[0];
    if (supportedLanguages.indexOf(languageCode) > -1) return languageCode;
    return null;
}
MapboxLanguage.prototype.onAdd = function(map) {
    this._map = map;
    this._map.on('style.load', this._initialStyleUpdate);
    this._container = document.createElement('div');
    return this._container;
};
MapboxLanguage.prototype.onRemove = function() {
    this._map.off('style.load', this._initialStyleUpdate);
    this._map = undefined;
};
if (typeof module.exports !== 'undefined') module.exports = MapboxLanguage;
else window.MapboxLanguage = MapboxLanguage;

},{}],"iqBhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMapStyle", ()=>createMapStyle);
parcelHelpers.export(exports, "sgRailTilesPath", ()=>sgRailTilesPath);
var _basemaps = require("@protomaps/basemaps");
const TILES_ROOT = 'https://assets.busrouter.sg/tiles/';
const sgTilesPath = TILES_ROOT + 'singapore.pmtiles';
const sgBuildingsTilesPath = TILES_ROOT + 'singapore-buildings.pmtiles';
const sgRailTilesPath = TILES_ROOT + 'sg-rail.geojson';
const GLYPHS_URL = 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf';
const SPRITE_URL = 'https://protomaps.github.io/basemaps-assets/sprites/v4/light';
const COLORS = {
    lightBlue: '#bee8f9',
    beige: '#f8f8f3',
    honeydew: '#deecd5',
    white: '#fff',
    whitesmoke: '#f0f0ee',
    mistyrose: '#fcf3f2',
    lavender: '#e9eaf2',
    lightBrown: '#d5d1ca',
    lightYellow: '#e5e5d2',
    linen: '#fbf0ea'
};
// Customize Protomaps light theme
const currentFlavor = (0, _basemaps.namedFlavor)('light');
const flavor = {
    ...currentFlavor,
    background: COLORS.lightBlue,
    water: COLORS.lightBlue,
    earth: COLORS.beige,
    landcover: {
        ...currentFlavor.landcover,
        farmland: COLORS.honeydew,
        forest: COLORS.honeydew,
        grassland: COLORS.honeydew
    },
    buildings: COLORS.whitesmoke,
    hospital: COLORS.mistyrose,
    park_a: COLORS.honeydew,
    park_b: COLORS.honeydew,
    wood_a: COLORS.honeydew,
    wood_b: COLORS.honeydew,
    scrub_a: COLORS.honeydew,
    scrub_b: COLORS.honeydew,
    aerodrome: COLORS.lavender,
    industrial: COLORS.beige,
    military: COLORS.beige,
    zoo: COLORS.honeydew,
    minor_a: COLORS.white,
    minor_service: COLORS.white,
    school: COLORS.linen,
    pedestrian: COLORS.beige,
    // walk paths
    other: COLORS.lightBrown,
    tunnel_other: COLORS.lightBrown,
    bridges_other: COLORS.lightBrown,
    tunnel_minor: COLORS.lightYellow,
    tunnel_link: COLORS.lightYellow,
    tunnel_major: COLORS.lightYellow,
    tunnel_highway: COLORS.lightYellow,
    bridges_major: COLORS.white,
    subplace_label_halo: COLORS.white,
    city_label_halo: COLORS.white,
    state_label_halo: COLORS.white
};
function createMapStyle({ lang = 'en' } = {}) {
    const mapLayers = (0, _basemaps.layers)('protomaps', flavor, {
        lang
    });
    const customMapLayers = [];
    let poisLayer = null;
    for (const layer of mapLayers){
        // Remove these layers
        if ([
            'address_label',
            'roads_rail'
        ].includes(layer.id)) continue;
        // Modify layers based on their ID or pattern
        switch(layer.id){
            // Replace buildings with Overture buildings
            case 'buildings':
                layer.filter = [
                    '!=',
                    [
                        'get',
                        'is_underground'
                    ],
                    true
                ];
                layer.source = 'buildings';
                layer['source-layer'] = 'building';
                layer.paint['fill-outline-color'] = '#d7d7c7';
                layer.paint['fill-opacity'] = 1;
                layer.minzoom = 15;
                break;
            case 'places_subplace':
                layer.layout['text-font'] = [
                    'Noto Sans Medium'
                ];
                layer.paint['text-halo-width'] = 2;
                layer.minzoom = 10;
                break;
            case 'places_locality':
                layer.minzoom = 14;
                break;
            case 'pois':
                poisLayer = layer;
                layer.minzoom = 16;
                // Re-adjust the kind filters in pois
                const poisFilterKindsLiteral = layer.filter?.find?.((v)=>v[0] === 'in')?.find((v)=>v[0] === 'literal');
                const poisFilterKinds = poisFilterKindsLiteral?.[1];
                if (poisFilterKinds?.length) poisFilterKindsLiteral[1] = [
                    'aerodrome',
                    'animal',
                    // 'arrow',
                    'beach',
                    // 'bench',
                    // 'bus_stop',
                    'capital',
                    // 'drinking_water',
                    'ferry_terminal',
                    'forest',
                    'garden',
                    'library',
                    'marina',
                    'park',
                    'peak',
                    'school',
                    'stadium',
                    // 'toilets',
                    'townspot',
                    // 'train_station',
                    'university',
                    'zoo'
                ];
                break;
        }
        if (/(water|road).+label/i.test(layer.id)) layer.minzoom = 16;
        // Uppercase road labels
        if (/road.+label/i.test(layer.id)) layer.layout['text-transform'] = 'uppercase';
        // Make roads wider on higher zoom levels
        const ROAD_WIDTH_MAX = 20;
        const ROAD_LARGER_MULTIPLIER = 2;
        const ROAD_LARGEST_MULTIPLIER = 6;
        if (layer['source-layer'] === 'roads' && layer.type === 'line') {
            const isCasing = /casing/i.test(layer.id);
            const lineWidth = isCasing ? layer.paint['line-gap-width'] : layer.paint['line-width'];
            const hasInterpolate = lineWidth?.[0] === 'interpolate';
            if (hasInterpolate) {
                const lastZoom = lineWidth[lineWidth.length - 2];
                const lastWidth = lineWidth[lineWidth.length - 1];
                const isMajor = /(major|highway)/i.test(layer.id);
                const largerWidth = lastWidth * (isMajor ? ROAD_LARGEST_MULTIPLIER : ROAD_LARGER_MULTIPLIER);
                if (lastZoom < ROAD_WIDTH_MAX) lineWidth.push(ROAD_WIDTH_MAX, largerWidth);
            }
        }
        // Add the layer to our custom array
        customMapLayers.push(layer);
        // Add buildings_label after pois
        if (layer.id === 'pois' && poisLayer) customMapLayers.push({
            id: 'buildings_label',
            type: 'symbol',
            source: 'buildings',
            'source-layer': 'building',
            minzoom: 15,
            layout: {
                'text-field': [
                    'get',
                    '@name'
                ],
                'text-font': [
                    'Noto Sans Regular'
                ],
                'text-max-width': 8,
                'text-size': poisLayer.layout['text-size'],
                'text-padding': 8
            },
            paint: {
                ...poisLayer.paint,
                'text-color': currentFlavor.pois.slategray
            }
        });
    }
    const mapStyle = {
        version: 8,
        glyphs: GLYPHS_URL,
        sprite: SPRITE_URL,
        sources: {
            protomaps: {
                type: 'vector',
                url: `pmtiles://${sgTilesPath}`,
                attribution: '<a href="https://protomaps.com" target="_blank">Protomaps</a> \xa9 <a href="https://openstreetmap.org" target="_blank">OpenStreetMap</a>'
            },
            buildings: {
                type: 'vector',
                url: `pmtiles://${sgBuildingsTilesPath}`,
                // Don't need OSM because already covered by the one above
                attribution: '<a href="https://overturemaps.org" target="_blank">Overture Maps Foundation</a>'
            },
            'sg-rail': {
                type: 'geojson',
                data: sgRailTilesPath,
                attribution: '\xa9 <a href="https://www.smrt.com.sg/" target="_blank" title="Singapore Mass Rapid Transit">SMRT</a> \xa9 <a href="https://www.sbstransit.com.sg/" target="_blank" title="Singapore Bus Services">SBS</a>'
            }
        },
        layers: customMapLayers
    };
    return mapStyle;
}

},{"@protomaps/basemaps":"4cB20","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"lXpo4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
const encode = (id)=>parseInt(id.replace(/\w/gi, (c)=>'' + c.charCodeAt()), 10);
const decode = (number)=>String.fromCharCode(...('' + number).match(/\w\w/gi));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4E495":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDisplay", ()=>timeDisplay);
parcelHelpers.export(exports, "sortServices", ()=>sortServices);
parcelHelpers.export(exports, "sortServicesPinned", ()=>sortServicesPinned);
const timeDisplay = (ms)=>{
    if (ms === null) return;
    const mins = Math.floor(ms / 1000 / 60);
    return mins <= 0 ? 'Arr' : `${mins}m`;
};
const sortServices = (a, b)=>{
    const a0 = a.toString()[0];
    const b0 = b.toString()[0];
    if (isNaN(a0) && !isNaN(b0)) return 1;
    if (!isNaN(a0) && isNaN(b0)) return -1;
    const result = a0 - b0;
    if (result !== 0) return result;
    return parseInt(a, 10) - parseInt(b, 10);
};
const sortServicesPinned = (pinnedServices)=>(a, b)=>{
        const pinA = pinnedServices.includes(a.no);
        const pinB = pinnedServices.includes(b.no);
        if (pinA && !pinB) return -1;
        else if (pinB && !pinA) return 1;
        else return sortServices(a.no, b.no);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kNdlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lscache = require("lscache");
var _lscacheDefault = parcelHelpers.interopDefault(_lscache);
exports.default = (url, timeout)=>{
    const data = (0, _lscacheDefault.default).get(url);
    if (data) return Promise.resolve(data);
    else return fetch(url).then((r)=>r.json()).then((r)=>{
        (0, _lscacheDefault.default).set(url, r, timeout);
        return r;
    });
};

},{"lscache":"1Js1m","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1Js1m":[function(require,module,exports,__globalThis) {
/**
 * lscache library
 * Copyright (c) 2011, Pamela Fox
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* jshint undef:true, browser:true, node:true */ /* global define */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (module.exports) // CommonJS/Node module
    module.exports = factory();
    else // Browser globals
    root.lscache = factory();
})(this, function() {
    // Prefix for all lscache keys
    var CACHE_PREFIX = 'lscache-';
    // Suffix for the key name on the expiration items in localStorage
    var CACHE_SUFFIX = '-cacheexpiration';
    // expiration date radix (set to Base-36 for most space savings)
    var EXPIRY_RADIX = 10;
    // time resolution in milliseconds
    var expiryMilliseconds = 60000;
    // ECMAScript max Date (epoch + 1e8 days)
    var maxDate = calculateMaxDate(expiryMilliseconds);
    var cachedStorage;
    var cachedJSON;
    var cacheBucket = '';
    var warnings = false;
    // Determines if localStorage is supported in the browser;
    // result is cached for better performance instead of being run each time.
    // Feature detection is based on how Modernizr does it;
    // it's not straightforward due to FF4 issues.
    // It's not run at parse-time as it takes 200ms in Android.
    function supportsStorage() {
        var key = '__lscachetest__';
        var value = key;
        if (cachedStorage !== undefined) return cachedStorage;
        // some browsers will throw an error if you try to access local storage (e.g. brave browser)
        // hence check is inside a try/catch
        try {
            if (!localStorage) return false;
        } catch (ex) {
            return false;
        }
        try {
            setItem(key, value);
            removeItem(key);
            cachedStorage = true;
        } catch (e) {
            // If we hit the limit, and we don't have an empty localStorage then it means we have support
            if (isOutOfSpace(e) && localStorage.length) cachedStorage = true; // just maxed it out and even the set test failed.
            else cachedStorage = false;
        }
        return cachedStorage;
    }
    // Check to set if the error is us dealing with being out of space
    function isOutOfSpace(e) {
        return e && (e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.name === 'QuotaExceededError');
    }
    // Determines if native JSON (de-)serialization is supported in the browser.
    function supportsJSON() {
        /*jshint eqnull:true */ if (cachedJSON === undefined) cachedJSON = window.JSON != null;
        return cachedJSON;
    }
    /**
   * Returns a string where all RegExp special characters are escaped with a \.
   * @param {String} text
   * @return {string}
   */ function escapeRegExpSpecialCharacters(text) {
        return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
    }
    /**
   * Returns the full string for the localStorage expiration item.
   * @param {String} key
   * @return {string}
   */ function expirationKey(key) {
        return key + CACHE_SUFFIX;
    }
    /**
   * Returns the number of minutes since the epoch.
   * @return {number}
   */ function currentTime() {
        return Math.floor(new Date().getTime() / expiryMilliseconds);
    }
    /**
   * Wrapper functions for localStorage methods
   */ function getItem(key) {
        return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
    }
    function setItem(key, value) {
        // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
        localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
    }
    function removeItem(key) {
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
    }
    function eachKey(fn) {
        var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
        // We first identify which keys to process
        var keysToProcess = [];
        var key, i;
        for(i = 0; i < localStorage.length; i++){
            key = localStorage.key(i);
            key = key && key.match(prefixRegExp);
            key = key && key[1];
            if (key && key.indexOf(CACHE_SUFFIX) < 0) keysToProcess.push(key);
        }
        // Then we apply the processing function to each key
        for(i = 0; i < keysToProcess.length; i++)fn(keysToProcess[i], expirationKey(keysToProcess[i]));
    }
    function flushItem(key) {
        var exprKey = expirationKey(key);
        removeItem(key);
        removeItem(exprKey);
    }
    function flushExpiredItem(key) {
        var exprKey = expirationKey(key);
        var expr = getItem(exprKey);
        if (expr) {
            var expirationTime = parseInt(expr, EXPIRY_RADIX);
            // Check if we should actually kick item out of storage
            if (currentTime() >= expirationTime) {
                removeItem(key);
                removeItem(exprKey);
                return true;
            }
        }
    }
    function warn(message, err) {
        if (!warnings) return;
        if (!('console' in window) || typeof window.console.warn !== 'function') return;
        window.console.warn("lscache - " + message);
        if (err) window.console.warn("lscache - The error was: " + err.message);
    }
    function calculateMaxDate(expiryMilliseconds) {
        return Math.floor(8.64e15 / expiryMilliseconds);
    }
    var lscache = {
        /**
     * Stores the value in localStorage. Expires after specified number of minutes.
     * @param {string} key
     * @param {Object|string} value
     * @param {number} time
     * @return {boolean} whether the value was inserted successfully
     */ set: function(key, value, time) {
            if (!supportsStorage()) return false;
            // If we don't get a string value, try to stringify
            // In future, localStorage may properly support storing non-strings
            // and this can be removed.
            if (!supportsJSON()) return false;
            try {
                value = JSON.stringify(value);
            } catch (e) {
                // Sometimes we can't stringify due to circular refs
                // in complex objects, so we won't bother storing then.
                return false;
            }
            try {
                setItem(key, value);
            } catch (e) {
                if (isOutOfSpace(e)) {
                    // If we exceeded the quota, then we will sort
                    // by the expire time, and then remove the N oldest
                    var storedKeys = [];
                    var storedKey;
                    eachKey(function(key, exprKey) {
                        var expiration = getItem(exprKey);
                        if (expiration) expiration = parseInt(expiration, EXPIRY_RADIX);
                        else // TODO: Store date added for non-expiring items for smarter removal
                        expiration = maxDate;
                        storedKeys.push({
                            key: key,
                            size: (getItem(key) || '').length,
                            expiration: expiration
                        });
                    });
                    // Sorts the keys with oldest expiration time last
                    storedKeys.sort(function(a, b) {
                        return b.expiration - a.expiration;
                    });
                    var targetSize = (value || '').length;
                    while(storedKeys.length && targetSize > 0){
                        storedKey = storedKeys.pop();
                        warn("Cache is full, removing item with key '" + storedKey.key + "'");
                        flushItem(storedKey.key);
                        targetSize -= storedKey.size;
                    }
                    try {
                        setItem(key, value);
                    } catch (e) {
                        // value may be larger than total quota
                        warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
                        return false;
                    }
                } else {
                    // If it was some other error, just give up.
                    warn("Could not add item with key '" + key + "'", e);
                    return false;
                }
            }
            // If a time is specified, store expiration info in localStorage
            if (time) setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
            else // In case they previously set a time, remove that info from localStorage.
            removeItem(expirationKey(key));
            return true;
        },
        /**
     * Retrieves specified value from localStorage, if not expired.
     * @param {string} key
     * @return {string|Object}
     */ get: function(key) {
            if (!supportsStorage()) return null;
            // Return the de-serialized item if not expired
            if (flushExpiredItem(key)) return null;
            // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
            var value = getItem(key);
            if (!value || !supportsJSON()) return value;
            try {
                // We can't tell if its JSON or a string, so we try to parse
                return JSON.parse(value);
            } catch (e) {
                // If we can't parse, it's probably because it isn't an object
                return value;
            }
        },
        /**
     * Removes a value from localStorage.
     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
     * @param {string} key
     */ remove: function(key) {
            if (!supportsStorage()) return;
            flushItem(key);
        },
        /**
     * Returns whether local storage is supported.
     * Currently exposed for testing purposes.
     * @return {boolean}
     */ supported: function() {
            return supportsStorage();
        },
        /**
     * Flushes all lscache items and expiry markers without affecting rest of localStorage
     */ flush: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushItem(key);
            });
        },
        /**
     * Flushes expired lscache items and expiry markers without affecting rest of localStorage
     */ flushExpired: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushExpiredItem(key);
            });
        },
        /**
     * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
     * @param {string} bucket
     */ setBucket: function(bucket) {
            cacheBucket = bucket;
        },
        /**
     * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
     */ resetBucket: function() {
            cacheBucket = '';
        },
        /**
     * @returns {number} The currently set number of milliseconds each time unit represents in
     *   the set() function's "time" argument.
     */ getExpiryMilliseconds: function() {
            return expiryMilliseconds;
        },
        /**
     * Sets the number of milliseconds each time unit represents in the set() function's
     *   "time" argument.
     * Sample values:
     *  1: each time unit = 1 millisecond
     *  1000: each time unit = 1 second
     *  60000: each time unit = 1 minute (Default value)
     *  360000: each time unit = 1 hour
     * @param {number} milliseconds
     */ setExpiryMilliseconds: function(milliseconds) {
            expiryMilliseconds = milliseconds;
            maxDate = calculateMaxDate(expiryMilliseconds);
        },
        /**
     * Sets whether to display warnings when an item is removed from the cache or not.
     */ enableWarnings: function(enabled) {
            warnings = enabled;
        }
    };
    // Return the module
    return lscache;
});

},{}],"kYEZr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = ()=>{
    const path = location.hash.replace(/^#/, '') || '/';
    if (path === '/') return {
        page: 'home'
    };
    let [_, page, value, subpage] = path.match(/(service|stop|between)s?\/([^\/]+)\/?([^\/]+)?/) || [];
    return {
        page,
        value,
        path,
        subpage
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"fAMC2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDistance);
function getDistance(x1, y1, x2, y2) {
    let xs = x2 - x1;
    let ys = y2 - y1;
    xs *= xs;
    ys *= ys;
    return Math.sqrt(xs + ys);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"tXXxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWalkingMinutes);
function getWalkingMinutes(distance) {
    // meters
    const walkingSpeed = 1.4; // meter/second
    return Math.ceil(distance / walkingSpeed / 60);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ixjNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePrevious);
var _hooks = require("preact/hooks");
function usePrevious(value) {
    const ref = (0, _hooks.useRef)();
    (0, _hooks.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

},{"preact/hooks":"2EbRR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hPAiX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preact = require("preact");
var _hooks = require("preact/hooks");
exports.default = ()=>{
    try {
        if (localStorage['busroutersg.noads'] === '1') return '';
    } catch (e) {}
    const adRef = (0, _hooks.useRef)();
    (0, _hooks.useEffect)(()=>{
        if (adRef.current?.offsetWidth > 0) {
            // Only push if the ad slot is visible
            adRef.current.id = 'bsa-zone_1623358681242-2_123456';
            window.optimize = window.optimize || {
                queue: []
            };
            window.optimize.queue.push(()=>{
                window.optimize.pushAll();
            });
        }
    }, []);
    const showFake = location.hostname === 'localhost';
    return (0, _preact.h)("div", {
        ref: adRef,
        class: "ads",
        style: showFake ? {
            backgroundColor: 'rgba(0,0,0,.03)',
            textAlign: 'center',
            minHeight: 160,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            color: 'gray'
        } : {
            backgroundColor: 'rgba(0,0,0,.03)',
            textAlign: 'center'
        }
    }, showFake && 'AD');
};

},{"preact":"fvkQC","preact/hooks":"2EbRR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6rBCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>About);
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _reactI18Next = require("react-i18next");
var _localeSelector = require("./LocaleSelector");
var _localeSelectorDefault = parcelHelpers.interopDefault(_localeSelector);
function About() {
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    const [hidden, setHidden] = (0, _hooks.useState)(true);
    (0, _hooks.useEffect)(()=>{
        try {
            const intro = localStorage.getItem('busroutersg.about');
            if (intro !== 'true') setHidden(false);
        } catch (e) {}
        const $logo = document.getElementById('logo');
        if ($logo) $logo.onclick = (e)=>{
            e.preventDefault();
            setHidden(!hidden);
        };
    }, []);
    return (0, _preact.h)("div", {
        id: "about",
        hidden: hidden,
        onClick: ()=>setHidden(true)
    }, (0, _preact.h)("section", {
        onClick: (e)=>e.stopPropagation()
    }, (0, _preact.h)("h2", null, t('app.name'), (0, _preact.h)("br", null), (0, _preact.h)("small", null, t('app.shortDescription'))), (0, _preact.h)("p", null, t('app.description')), (0, _preact.h)((0, _localeSelectorDefault.default), null), (0, _preact.h)("hr", null), (0, _preact.h)("p", null, (0, _preact.h)((0, _reactI18Next.Trans), {
        i18nKey: "about.disclaimerCopyright"
    }, (0, _preact.h)("a", {
        href: "https://github.com/cheeaun/busrouter-sg",
        target: "_blank",
        rel: "noopener"
    }, "Built"), "&", (0, _preact.h)("a", {
        href: "/visualization/",
        target: "_blank",
        rel: "noopener"
    }, "visualized"), "by", (0, _preact.h)("a", {
        href: "http://twitter.com/cheeaun",
        target: "_blank",
        rel: "noopener"
    }, "@cheeaun"), ". Data", (0, _preact.h)("a", {
        href: "http://www.mytransport.sg/",
        target: "_blank",
        rel: "noopener",
        title: "Land Transport Authority"
    }, "\xA9 LTA"), ".")), (0, _preact.h)("p", null, (0, _preact.h)((0, _reactI18Next.Trans), {
        i18nKey: "about.sisterSites"
    }, "Sister sites:", (0, _preact.h)("a", {
        href: "https://railrouter.sg/",
        target: "_blank",
        rel: "noopener"
    }, "\uD83D\uDE86 RailRouter SG"), ' ', (0, _preact.h)("a", {
        href: "https://taxirouter.sg/",
        target: "_blank",
        rel: "noopener"
    }, "\uD83D\uDE96 TaxiRouter SG"))), (0, _preact.h)("p", null, (0, _preact.h)("a", {
        class: "donation-box",
        href: "https://www.buymeacoffee.com/cheeaun",
        target: "_blank",
        rel: "noopener"
    }, t('about.liking'), (0, _preact.h)("br", null), t('about.treatCoffee'))), (0, _preact.h)("div", {
        class: "popover-buttons"
    }, (0, _preact.h)("button", {
        class: "popover-button",
        onClick: ()=>{
            setHidden(true);
            try {
                localStorage.setItem('busroutersg.about', 'true');
            } catch (e) {}
        }
    }, t('about.explore')))));
}

},{"preact":"fvkQC","preact/hooks":"2EbRR","react-i18next":"3s9bS","./LocaleSelector":"jTEXS","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"8ZuIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BusServicesArrival);
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _cheapRuler = require("cheap-ruler");
var _cheapRulerDefault = parcelHelpers.interopDefault(_cheapRuler);
var _reactI18Next = require("react-i18next");
var _specialID = require("../utils/specialID");
var _getRoute = require("../utils/getRoute");
var _getRouteDefault = parcelHelpers.interopDefault(_getRoute);
var _rafInterval = require("../utils/rafInterval");
var _bus = require("../utils/bus");
var _arrivalTimeText = require("./ArrivalTimeText");
var _arrivalTimeTextDefault = parcelHelpers.interopDefault(_arrivalTimeText);
var _busTinyPng = require("../images/bus-tiny.png");
var _busTinyPngDefault = parcelHelpers.interopDefault(_busTinyPng);
const ruler = new (0, _cheapRulerDefault.default)(1.3);
const setupBusesStopLayerOnce = (map)=>{
    if (!map) return;
    if (!map.getSource('buses-stop')) {
        map.addSource('buses-stop', {
            type: 'geojson',
            tolerance: 10,
            data: {
                type: 'FeatureCollection',
                features: []
            }
        });
        if (!map.hasImage('bus-tiny')) map.loadImage((0, _busTinyPngDefault.default), (e, img)=>{
            if (!map.hasImage('bus-tiny')) map.addImage('bus-tiny', img);
        });
        map.addLayer({
            id: 'buses-stop',
            type: 'symbol',
            source: 'buses-stop',
            minzoom: 11,
            layout: {
                'icon-image': 'bus-tiny',
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
                'icon-size': [
                    'step',
                    [
                        'zoom'
                    ],
                    0.25,
                    15,
                    0.3,
                    16,
                    0.4
                ],
                'text-field': [
                    'step',
                    [
                        'zoom'
                    ],
                    '',
                    15,
                    [
                        'get',
                        'number'
                    ]
                ],
                'text-optional': true,
                'text-size': 10,
                // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
                'text-font': [
                    'Noto Sans Medium'
                ],
                'text-variable-anchor': [
                    'left',
                    'right',
                    'bottom',
                    'top'
                ],
                'text-justify': 'auto',
                'text-padding': [
                    'step',
                    [
                        'zoom'
                    ],
                    4,
                    15,
                    6,
                    16,
                    8
                ]
            },
            paint: {
                'text-color': '#00454d',
                'text-halo-color': '#fff',
                'text-halo-width': 2
            }
        });
    }
};
const removeMapBuses = (map)=>{
    if (!map) return;
    map.getSource('buses-stop')?.setData({
        type: 'FeatureCollection',
        features: []
    });
};
const timeout = (n)=>new Promise((f)=>setTimeout(f, n));
function BusServicesArrival({ services, id, map, active, showBusesOnMap }) {
    if (!id) return;
    const { t } = (0, _reactI18Next.useTranslation)();
    const [isLoading, setIsLoading] = (0, _hooks.useState)(false);
    const [servicesArrivals, setServicesArrivals] = (0, _hooks.useState)({});
    const [servicesIssues, setServicesIssues] = (0, _hooks.useState)([]);
    const [liveBusCount, setLiveBusCount] = (0, _hooks.useState)(0);
    const [oneServiceHasMultipleDirections, setOneServiceHasMultipleDirections] = (0, _hooks.useState)(false);
    const route = (0, _getRouteDefault.default)();
    let controller;
    const renderStopsTimeout = (0, _hooks.useRef)();
    const fetchServices = (0, _hooks.useCallback)(()=>{
        setIsLoading(true);
        controller = new AbortController();
        fetch(`https://arrivelah2.busrouter.sg/?id=${id}`, {
            signal: controller.signal
        }).then((res)=>res.json()).then((results)=>{
            const servicesArrivals = {};
            const { services } = results;
            services.forEach((service)=>{
                if (!servicesArrivals[service.no] || servicesArrivals[service.no] > service.next.duration_ms // if there is a service with multiple directions, we only want the one with the shortest duration
                ) servicesArrivals[service.no] = service.next.duration_ms;
            });
            setServicesArrivals(servicesArrivals);
            setIsLoading(false);
            // check for issues (duplicate services, multiple visits)
            const servicesWithIssues = [];
            services.forEach((service, i)=>{
                const hasDuplicateServices = services.findIndex((s)=>s.no === service.no) !== i;
                if (hasDuplicateServices) servicesWithIssues.push(service.no);
                const { next, next2, next3 } = service;
                const hasMultipleVisits = next?.visit_number > 1 || next2?.visit_number > 1 || next3?.visit_number > 1;
                if (hasMultipleVisits) servicesWithIssues.push(service.no);
            });
            setServicesIssues(servicesWithIssues);
            const hasIssues = servicesWithIssues.length > 0;
            setOneServiceHasMultipleDirections(hasIssues);
            if (showBusesOnMap) {
                setupBusesStopLayerOnce(map);
                renderStopsTimeout.current = setTimeout(()=>{
                    const servicesWithCoords = services.filter((s)=>s.no && s.next.lat > 0);
                    setLiveBusCount(servicesWithCoords.length);
                    const pointMargin = 100;
                    const servicesWithFixedCoordsPromises = servicesWithCoords.map(async (s)=>{
                        await timeout(0); // Forces this to be async
                        const coords = [
                            s.next.lng,
                            s.next.lat
                        ];
                        const point = map.project(coords);
                        let shortestDistance = Infinity;
                        let nearestCoords;
                        if (point.x && point.y) {
                            const features = map.queryRenderedFeatures([
                                [
                                    point.x - pointMargin,
                                    point.y - pointMargin
                                ],
                                [
                                    point.x + pointMargin,
                                    point.y + pointMargin
                                ]
                            ], {
                                validate: false
                            }).filter((f)=>{
                                return f.sourceLayer === 'road' && f.layer.type === 'line' && f.properties.class != 'path' && !/(pedestrian|sidewalk|steps)/.test(f.layer.id);
                            });
                            features.forEach((f)=>{
                                const nearestPoint = ruler.pointOnLine(f.geometry.coordinates, coords);
                                if (nearestPoint.t) {
                                    const distance = ruler.distance(coords, nearestPoint.point);
                                    if (distance < shortestDistance) {
                                        shortestDistance = distance;
                                        nearestCoords = nearestPoint.point;
                                    }
                                }
                            });
                            if (nearestCoords && shortestDistance * 1000 < 10) // Only within 10m
                            s.next = {
                                lng: nearestCoords[0],
                                lat: nearestCoords[1]
                            };
                        }
                        return s;
                    });
                    requestAnimationFrame(async ()=>{
                        const servicesWithFixedCoords = await Promise.all(servicesWithFixedCoordsPromises);
                        map.getSource('buses-stop').setData({
                            type: 'FeatureCollection',
                            features: servicesWithFixedCoords.map((s)=>({
                                    type: 'Feature',
                                    id: (0, _specialID.encode)(s.no),
                                    properties: {
                                        number: s.no
                                    },
                                    geometry: {
                                        type: 'Point',
                                        coordinates: [
                                            s.next.lng,
                                            s.next.lat
                                        ]
                                    }
                                }))
                        });
                    });
                }, map.loaded() ? 0 : 1000);
            }
        }).catch(()=>{
        // Silent fail
        });
    }, [
        id
    ]);
    (0, _hooks.useEffect)(()=>{
        let intervalID;
        if (active) intervalID = (0, _rafInterval.setRafInterval)(fetchServices, 15000); // 15 seconds
        return ()=>{
            (0, _rafInterval.clearRafInterval)(intervalID);
            controller?.abort();
            clearTimeout(renderStopsTimeout.current);
            removeMapBuses(map);
        };
    }, [
        id,
        active,
        showBusesOnMap
    ]);
    const servicesValue = route.value?.split('~') || [];
    return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("p", {
        class: `services-list ${isLoading ? 'loading' : ''}`
    }, services.sort((0, _bus.sortServices)).map((service)=>(0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("a", {
            href: `#/services/${service}`,
            class: `service-tag ${route.page === 'service' && servicesValue.includes(service) ? 'current' : ''}`
        }, service, servicesIssues.includes(service) && " \u26A0\uFE0F", servicesArrivals[service] && (0, _preact.h)("span", null, (0, _preact.h)((0, _arrivalTimeTextDefault.default), {
            ms: servicesArrivals[service]
        }))), ' '))), oneServiceHasMultipleDirections && (0, _preact.h)("div", {
        class: "callout warning iconic"
    }, t('stop.multipleDirectionsWarning')), showBusesOnMap && liveBusCount > 0 && (0, _preact.h)("p", {
        style: {
            marginTop: 5,
            fontSize: '.8em'
        }
    }, (0, _preact.h)("span", {
        class: "live"
    }, t('common.live')), ' ', (0, _preact.h)("img", {
        src: (0, _busTinyPngDefault.default),
        width: "16",
        alt: ""
    }), ' ', t('stop.liveBusTrack', {
        count: liveBusCount
    })));
}

},{"preact":"fvkQC","preact/hooks":"2EbRR","cheap-ruler":"esqZH","react-i18next":"3s9bS","../utils/specialID":"lXpo4","../utils/getRoute":"kYEZr","../utils/rafInterval":"aSR6k","../utils/bus":"4E495","./ArrivalTimeText":"7XWv2","../images/bus-tiny.png":"50ryH","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aSR6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setRafInterval", ()=>setRafInterval);
parcelHelpers.export(exports, "clearRafInterval", ()=>clearRafInterval);
const setRafInterval = (fn, delay)=>{
    const id = {};
    function tick() {
        fn();
        id.timeout = setTimeout(()=>{
            id.raf = requestAnimationFrame(tick);
        }, delay);
    }
    tick();
    return id;
};
const clearRafInterval = (id)=>{
    if (!id) return;
    const { timeout, raf } = id;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7XWv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrivalTimeText);
var _preact = require("preact");
var _reactI18Next = require("react-i18next");
function ArrivalTimeText({ ms }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    if (ms === null) return;
    const mins = Math.floor(ms / 1000 / 60);
    return mins <= 0 ? t('glossary.arriving') : t('glossary.arrivingMinutes', {
        count: mins
    });
}

},{"preact":"fvkQC","react-i18next":"3s9bS","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"50ryH":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("lkrLs");

},{}],"kT5y8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _maplibreGl = require("maplibre-gl");
var _maplibreGlDefault = parcelHelpers.interopDefault(_maplibreGl);
var _checkGeolocationSupport = require("../utils/checkGeolocationSupport");
var _checkGeolocationSupportDefault = parcelHelpers.interopDefault(_checkGeolocationSupport);
var _compassHeading = require("../utils/compassHeading");
var _compassHeadingDefault = parcelHelpers.interopDefault(_compassHeading);
class GeolocateControl {
    _watching = false;
    _locking = false;
    _setup = false;
    _currentLocation = null;
    _buttonClicked = false;
    _orientationGranted = false;
    _retries = 0;
    constructor(options){
        this.options = Object.assign({
            offset: [
                0,
                0
            ],
            onClick: ()=>{}
        }, options);
    }
    onAdd(map) {
        this._map = map;
        const container = document.createElement('div');
        container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        this._container = container;
        (0, _checkGeolocationSupportDefault.default)(this._setupUI);
        return this._container;
    }
    _setupUI = (supported)=>{
        supported;
        const button = document.createElement('button');
        button.className = 'maplibregl-ctrl-icon maplibregl-ctrl-custom-geolocate';
        button.type = 'button';
        button.innerHTML = `<svg viewBox="0 0 16 15" width="18" height="18">
    <path d="M.75 5.94c-.3.14-.51.33-.63.57a1.12 1.12 0 00.3 1.38c.2.17.47.26.8.27l5.54.02c.06 0 .09 0 .1.02.02.02.02.05.02.1l.02 5.5c.01.35.1.62.28.82.17.2.39.33.64.37.26.04.51-.01.77-.14.25-.14.45-.37.6-.7l5.7-12.34c.16-.32.22-.61.18-.87a1.05 1.05 0 00-.32-.65c-.17-.16-.4-.26-.67-.28-.28-.03-.58.03-.9.18L.75 5.94z"/>
    <path fill="#fff" class="inner" d="M2.37 6.74h-.02c0-.01 0-.02.02-.03l10.9-4.95h.03l-.01.03-4.97 10.88c0 .02-.01.02-.02.02v-.02l.04-5.31a.64.64 0 00-.66-.66l-5.31.04z"/>
  </svg>`;
        button.addEventListener('click', this._clickButton, false);
        this._button = button;
        this._container.appendChild(this._button);
        const dot = document.createElement('div');
        dot.innerHTML = `<div class="user-location-dot"></div>
      <div class="user-location-compass" hidden></div>`;
        // <div class="user-location-accuracy"></div>`;
        dot.className = 'user-location';
        this._dot = new (0, _maplibreGlDefault.default).Marker({
            element: dot,
            rotationAlignment: 'map'
        });
        const dotElement = this._dot.getElement();
        this._compass = dotElement.querySelector('.user-location-compass');
        // this._accuracy = dotElement.querySelector('.user-location-accuracy');
        this._map.on('movestart', (e)=>{
            if (!e.geolocateSource && this._locking) {
                this._locking = false;
                this._updateButtonState(null);
            }
        });
        this._setup = true;
        if (supported === 'granted') this._clickButton(null, false);
    };
    _updateButtonState = (state)=>{
        const { classList } = this._button;
        classList.remove('loading');
        classList.remove('active');
        if (state) classList.add(state);
    };
    _flyToCurrentLocation = ()=>{
        const map = this._map;
        const { _currentLocation: center } = this;
        const { offset: _offset } = this.options;
        const offset = typeof _offset === 'function' ? _offset() : _offset;
        const { x, y } = map.project(center);
        const { offsetWidth, offsetHeight, offsetLeft, offsetTop } = map.getContainer();
        const margin = Math.max(offsetWidth, offsetHeight);
        const withinBounds = x > offsetLeft - margin && x < offsetWidth + margin && y > offsetTop - margin && y < offsetHeight + margin;
        // console.log(center, x, y, offsetLeft, offsetTop, offsetWidth, offsetHeight);
        const eventData = {
            geolocateSource: true
        };
        if (withinBounds) {
            if (map.getZoom() < 14) map.easeTo({
                center,
                zoom: 18,
                duration: 300,
                offset,
                animate: false
            }, eventData);
            else map.flyTo({
                center,
                zoom: 18,
                speed: 1.5,
                duration: 2000,
                offset
            }, eventData);
        } else map.easeTo({
            center,
            zoom: 18,
            duration: 300,
            offset,
            animate: false
        }, eventData);
    };
    _setHeading = (e)=>{
        if (!this._watching) return;
        if (!e || e.alpha === null) return;
        this._compass.hidden = false;
        const heading = e.compassHeading || e.webkitCompassHeading || (0, _compassHeadingDefault.default)(e.alpha, e.beta, e.gamma);
        // -60deg rotateX is for *tilting* the compass "box" to look like a trapezoid
        // this._compass.style.transform = `rotate(${Math.round(
        //   heading,
        // )}deg) scale(4)`;
        this._dot.setRotation(heading);
    };
    _clickButton = (e, locking = true)=>{
        if (e) e.preventDefault();
        if (!this._setup) return;
        const { onClick } = this.options;
        if (this._watching) {
            this._updateButtonState('active');
            this._flyToCurrentLocation();
            this._locking = true;
            onClick(this._currentLocation);
        } else {
            this._updateButtonState('loading');
            this._buttonClicked = true;
            this._locking = locking;
            let deviceorientation;
            this._watching = navigator.geolocation.watchPosition((position)=>{
                const { latitude, longitude } = position.coords;
                if (`${[
                    latitude,
                    longitude
                ]}` === `${this._currentLocation}`) return; // No idea why
                // console.log({ latitude, longitude });
                this._currentLocation = [
                    longitude,
                    latitude
                ];
                this._dot.setLngLat(this._currentLocation);
                if (!this._dot._addedToMap) {
                    this._dot.addTo(this._map);
                    this._dot._addedToMap = true;
                }
                if (this._locking) {
                    this._updateButtonState('active');
                    this._flyToCurrentLocation();
                } else this._updateButtonState(null);
                if (this._buttonClicked) {
                    // Differentiate between initiated from button click or watchPosition subsequent runs
                    this._buttonClicked = false;
                    onClick(this._currentLocation);
                }
                this._watching = true;
            }, (e)=>{
                this._locking = false;
                this._watching = false;
                this._buttonClicked = false;
                this._updateButtonState(null);
                navigator.geolocation.clearWatch(this._watching);
                if (deviceorientation) window.removeEventListener(deviceorientation, this._setHeading);
                this._retries++;
                if (e.code === 1) // PERMISSION_DENIED
                alert('Looks like location tracking is blocked on your browser. Please enable it in the settings to use this feature.');
                else {
                    if (this._retries > 3) return;
                    // Retry again
                    this._clickButton();
                }
            }, {
                enableHighAccuracy: true,
                timeout: 60000,
                // 1min
                maximumAge: 1000 // 1s
            });
            if (window.DeviceOrientationEvent) {
                // https://developers.google.com/web/updates/2016/03/device-orientation-changes
                // https://stackoverflow.com/a/47870694/20838
                if (location.hostname === 'localhost') // Stupid bug with Chrome
                // `ondeviceorientationabsolute` is true but always return empty values
                deviceorientation = 'deviceorientation';
                else deviceorientation = 'ondeviceorientationabsolute' in window ? 'deviceorientationabsolute' : 'deviceorientation';
                window.addEventListener(deviceorientation, this._setHeading, false);
                if (!this._orientationGranted) {
                    if (typeof DeviceOrientationEvent.requestPermission === 'function') DeviceOrientationEvent.requestPermission().then(function(permissionState) {
                        if (permissionState === 'granted') this._orientationGranted = true;
                    }).catch((e)=>{});
                }
            }
        }
    };
}
exports.default = GeolocateControl;

},{"maplibre-gl":"lyGpb","../utils/checkGeolocationSupport":"1Knwb","../utils/compassHeading":"3BXuA","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1Knwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>checkGeolocationSupport);
let supportsGeolocation;
function checkGeolocationSupport(callback) {
    if (supportsGeolocation !== undefined) callback(supportsGeolocation);
    else if (window.navigator.permissions !== undefined) // navigator.permissions has incomplete browser support
    // http://caniuse.com/#feat=permissions-api
    // Test for the case where a browser disables Geolocation because of an
    // insecure origin
    window.navigator.permissions.query({
        name: 'geolocation'
    }).then((p)=>{
        supportsGeolocation = p.state === 'denied' ? false : p.state;
        callback(supportsGeolocation);
    });
    else {
        supportsGeolocation = !!window.navigator.geolocation;
        callback(supportsGeolocation);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3BXuA":[function(require,module,exports,__globalThis) {
// https://stackoverflow.com/a/21829819/20838
// http://w3c.github.io/deviceorientation/spec-source-orientation.html#worked-example
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compassHeading);
const degtorad = Math.PI / 180; // Degree-to-Radian conversion
function compassHeading(alpha, beta, gamma) {
    const _x = beta ? beta * degtorad : 0; // beta value
    const _y = gamma ? gamma * degtorad : 0; // gamma value
    const _z = alpha ? alpha * degtorad : 0; // alpha value
    const cX = Math.cos(_x);
    const cY = Math.cos(_y);
    const cZ = Math.cos(_z);
    const sX = Math.sin(_x);
    const sY = Math.sin(_y);
    const sZ = Math.sin(_z);
    // Calculate Vx and Vy components
    const Vx = -cZ * sY - sZ * sX * cY;
    const Vy = -sZ * sY + cZ * sX * cY;
    // Calculate compass heading
    let compassHeading = Math.atan(Vx / Vy);
    // Convert compass heading to use whole unit circle
    if (Vy < 0) compassHeading += Math.PI;
    else if (Vx < 0) compassHeading += 2 * Math.PI;
    return compassHeading * (180 / Math.PI); // Compass Heading (in degrees)
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"6sgRh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BetweenRoutes);
var _preact = require("preact");
function BetweenRoutes(props) {
    const { results, nearbyStart, nearbyEnd, onClickRoute } = props;
    if (!results.length) return (0, _preact.h)("div", {
        class: "between-block between-nada"
    }, "\uD83D\uDE14 No routes available.");
    return (0, _preact.h)("div", {
        class: "between-block"
    }, results.map((result)=>{
        const { stopsBetween } = result;
        return (0, _preact.h)("div", {
            class: `between-item ${nearbyStart ? 'nearby-start' : ''}  ${nearbyEnd ? 'nearby-end' : ''}`,
            onClick: (e)=>onClickRoute(e, result)
        }, (0, _preact.h)("div", {
            class: "between-inner"
        }, (0, _preact.h)("div", {
            class: `between-services ${result.endService ? '' : 'full'}`
        }, (0, _preact.h)("span", {
            class: "start"
        }, result.startService), !!result.endService && (0, _preact.h)("span", {
            class: "end"
        }, result.endService)), (0, _preact.h)("div", {
            class: `between-stops ${stopsBetween.length ? '' : 'nada'}`
        }, result.startStop && (0, _preact.h)("span", {
            class: "start"
        }, result.startStop.number), (0, _preact.h)("span", {
            class: `betweens betweens-${Math.min(6, stopsBetween.length)}`
        }, !!stopsBetween.length && (stopsBetween.length === 1 ? stopsBetween[0] : `${stopsBetween.length} stops`)), result.endStop && (0, _preact.h)("span", {
            class: "end"
        }, result.endStop.number))));
    }));
}

},{"preact":"fvkQC","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"M6shC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollableContainer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _useResizeObserver = require("../utils/useResizeObserver");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);
function ScrollableContainer(props) {
    const { children, scrollToTopKey, ...otherProps } = props;
    const ref = (0, _hooks.useRef)(null);
    const { width, height } = (0, _useResizeObserverDefault.default)({
        ref
    });
    const [scrollShadow, setScrollShadow] = (0, _hooks.useState)('bottom');
    (0, _hooks.useEffect)(()=>{
        // console.log('TRIGGER');
        const { current: el } = ref;
        const { scrollHeight, offsetHeight } = el;
        const handleScroll = ()=>{
            // console.log('SCROLL');
            if (el.scrollTop <= 0) setScrollShadow('bottom');
            else if (el.scrollTop + el.offsetHeight >= el.scrollHeight) setScrollShadow('top');
            else setScrollShadow('both');
        };
        const scrollable = scrollHeight > offsetHeight + 5; // Magic threshold
        if (scrollable) {
            handleScroll();
            el.addEventListener('scroll', handleScroll);
        } else setScrollShadow('');
        return ()=>el.removeEventListener('scroll', handleScroll);
    }, [
        width,
        height
    ]);
    // Scroll to top when `scrollToTopKey` changes
    (0, _hooks.useEffect)(()=>{
        ref.current.scrollTop = 0;
    }, [
        scrollToTopKey
    ]);
    return (0, _preact.h)("div", (0, _extendsDefault.default)({}, otherProps, {
        ref: ref,
        "data-scroll-shadow": scrollShadow
    }), children);
}

},{"@babel/runtime/helpers/esm/extends":"5DN8g","preact":"fvkQC","preact/hooks":"2EbRR","../utils/useResizeObserver":"jhUUF","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5DN8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jhUUF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resizeObserver = require("@juggle/resize-observer");
var _useResizeObserver = require("use-resize-observer");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);
if (!window.ResizeObserver) window.ResizeObserver = (0, _resizeObserver.ResizeObserver);
exports.default = (0, _useResizeObserverDefault.default);

},{"@juggle/resize-observer":"1XtGL","use-resize-observer":"45K1w","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1XtGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserver", ()=>(0, _resizeObserver.ResizeObserver));
parcelHelpers.export(exports, "ResizeObserverEntry", ()=>(0, _resizeObserverEntry.ResizeObserverEntry));
parcelHelpers.export(exports, "ResizeObserverSize", ()=>(0, _resizeObserverSize.ResizeObserverSize));
var _resizeObserver = require("../ResizeObserver");
var _resizeObserverEntry = require("../ResizeObserverEntry");
var _resizeObserverSize = require("../ResizeObserverSize");

},{"../ResizeObserver":"ohFjP","../ResizeObserverEntry":"9YdJM","../ResizeObserverSize":"koYTP","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ohFjP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserver", ()=>ResizeObserver);
var _resizeObserverController = require("./ResizeObserverController");
var _element = require("./utils/element");
var ResizeObserver = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, _resizeObserverController.ResizeObserverController).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, _element.isElement)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, _resizeObserverController.ResizeObserverController).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, _element.isElement)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, _resizeObserverController.ResizeObserverController).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, _resizeObserverController.ResizeObserverController).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();

},{"./ResizeObserverController":"1sZB9","./utils/element":"2gbnB","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1sZB9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverController", ()=>ResizeObserverController);
var _scheduler = require("./utils/scheduler");
var _resizeObservation = require("./ResizeObservation");
var _resizeObserverDetail = require("./ResizeObserverDetail");
var _resizeObservers = require("./utils/resizeObservers");
var observerMap = new WeakMap();
var getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var ResizeObserverController = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, _resizeObserverDetail.ResizeObserverDetail)(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, _resizeObservers.resizeObservers).push(detail);
            detail.observationTargets.push(new (0, _resizeObservation.ResizeObservation)(target, options && options.box));
            (0, _scheduler.updateCount)(1);
            (0, _scheduler.scheduler).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, _resizeObservers.resizeObservers).splice((0, _resizeObservers.resizeObservers).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, _scheduler.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();

},{"./utils/scheduler":"4Ghsq","./ResizeObservation":"Akdxw","./ResizeObserverDetail":"3FGcb","./utils/resizeObservers":"eJHXM","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4Ghsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduler", ()=>scheduler);
parcelHelpers.export(exports, "updateCount", ()=>updateCount);
var _process = require("./process");
var _global = require("./global");
var _queueResizeObserver = require("./queueResizeObserver");
var watching = 0;
var isWatching = function() {
    return !!watching;
};
var CATCH_PERIOD = 250;
var observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = CATCH_PERIOD;
        if (scheduled) return;
        scheduled = true;
        var until = time(timeout);
        (0, _queueResizeObserver.queueResizeObserver)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, _process.process)();
            } finally{
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, observerConfig);
        };
        document.body ? cb() : (0, _global.global).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function(name) {
                return (0, _global.global).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function(name) {
                return (0, _global.global).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var scheduler = new Scheduler();
var updateCount = function(n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};

},{"./process":"g8me7","./global":"bCKYd","./queueResizeObserver":"hWT5z","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"g8me7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "process", ()=>process);
var _hasActiveObservations = require("../algorithms/hasActiveObservations");
var _hasSkippedObservations = require("../algorithms/hasSkippedObservations");
var _deliverResizeLoopError = require("../algorithms/deliverResizeLoopError");
var _broadcastActiveObservations = require("../algorithms/broadcastActiveObservations");
var _gatherActiveObservationsAtDepth = require("../algorithms/gatherActiveObservationsAtDepth");
var process = function() {
    var depth = 0;
    (0, _gatherActiveObservationsAtDepth.gatherActiveObservationsAtDepth)(depth);
    while((0, _hasActiveObservations.hasActiveObservations)()){
        depth = (0, _broadcastActiveObservations.broadcastActiveObservations)();
        (0, _gatherActiveObservationsAtDepth.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0, _hasSkippedObservations.hasSkippedObservations)()) (0, _deliverResizeLoopError.deliverResizeLoopError)();
    return depth > 0;
};

},{"../algorithms/hasActiveObservations":"COnE5","../algorithms/hasSkippedObservations":"glZJc","../algorithms/deliverResizeLoopError":"jemeX","../algorithms/broadcastActiveObservations":"9WiIB","../algorithms/gatherActiveObservationsAtDepth":"aMzs4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"COnE5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasActiveObservations", ()=>hasActiveObservations);
var _resizeObservers = require("../utils/resizeObservers");
var hasActiveObservations = function() {
    return (0, _resizeObservers.resizeObservers).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};

},{"../utils/resizeObservers":"eJHXM","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"eJHXM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeObservers", ()=>resizeObservers);
var resizeObservers = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"glZJc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSkippedObservations", ()=>hasSkippedObservations);
var _resizeObservers = require("../utils/resizeObservers");
var hasSkippedObservations = function() {
    return (0, _resizeObservers.resizeObservers).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};

},{"../utils/resizeObservers":"eJHXM","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"jemeX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deliverResizeLoopError", ()=>deliverResizeLoopError);
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9WiIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "broadcastActiveObservations", ()=>broadcastActiveObservations);
var _resizeObservers = require("../utils/resizeObservers");
var _resizeObserverEntry = require("../ResizeObserverEntry");
var _calculateDepthForNode = require("./calculateDepthForNode");
var _calculateBoxSize = require("./calculateBoxSize");
var broadcastActiveObservations = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, _resizeObservers.resizeObservers).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, _resizeObserverEntry.ResizeObserverEntry)(ot.target);
            var targetDepth = (0, _calculateDepthForNode.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, _calculateBoxSize.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

},{"../utils/resizeObservers":"eJHXM","../ResizeObserverEntry":"9YdJM","./calculateDepthForNode":"aZZX7","./calculateBoxSize":"2QAoC","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"9YdJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverEntry", ()=>ResizeObserverEntry);
var _calculateBoxSize = require("./algorithms/calculateBoxSize");
var _freeze = require("./utils/freeze");
var ResizeObserverEntry = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, _calculateBoxSize.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, _freeze.freeze)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, _freeze.freeze)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, _freeze.freeze)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();

},{"./algorithms/calculateBoxSize":"2QAoC","./utils/freeze":"5lCoI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2QAoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBoxSize", ()=>calculateBoxSize);
parcelHelpers.export(exports, "calculateBoxSizes", ()=>calculateBoxSizes);
var _resizeObserverBoxOptions = require("../ResizeObserverBoxOptions");
var _resizeObserverSize = require("../ResizeObserverSize");
var _domrectReadOnly = require("../DOMRectReadOnly");
var _element = require("../utils/element");
var _freeze = require("../utils/freeze");
var _global = require("../utils/global");
var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = /msie|trident/i.test((0, _global.global).navigator && (0, _global.global).navigator.userAgent);
var parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, _resizeObserverSize.ResizeObserverSize)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = (0, _freeze.freeze)({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new (0, _domrectReadOnly.DOMRectReadOnly)(0, 0, 0, 0)
});
var calculateBoxSizes = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if (cache.has(target) && !forceRecalculation) return cache.get(target);
    if ((0, _element.isHidden)(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, _element.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, _freeze.freeze)({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, _domrectReadOnly.DOMRectReadOnly)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function(target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

},{"../ResizeObserverBoxOptions":"3ccM9","../ResizeObserverSize":"koYTP","../DOMRectReadOnly":"4SslW","../utils/element":"2gbnB","../utils/freeze":"5lCoI","../utils/global":"bCKYd","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3ccM9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverBoxOptions", ()=>ResizeObserverBoxOptions);
var ResizeObserverBoxOptions;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"koYTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverSize", ()=>ResizeObserverSize);
var _freeze = require("./utils/freeze");
var ResizeObserverSize = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, _freeze.freeze)(this);
    }
    return ResizeObserverSize;
}();

},{"./utils/freeze":"5lCoI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5lCoI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freeze", ()=>freeze);
var freeze = function(obj) {
    return Object.freeze(obj);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"4SslW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMRectReadOnly", ()=>DOMRectReadOnly);
var _freeze = require("./utils/freeze");
var DOMRectReadOnly = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, _freeze.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();

},{"./utils/freeze":"5lCoI","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"2gbnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVG", ()=>isSVG);
parcelHelpers.export(exports, "isHidden", ()=>isHidden);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isReplacedElement", ()=>isReplacedElement);
var isSVG = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var isHidden = function(target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function(obj) {
    var _a, _b;
    if (obj instanceof Element) return true;
    var scope = (_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"bCKYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "global", ()=>global);
var global = typeof window !== 'undefined' ? window : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aZZX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateDepthForNode", ()=>calculateDepthForNode);
var _element = require("../utils/element");
var calculateDepthForNode = function(node) {
    if ((0, _element.isHidden)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

},{"../utils/element":"2gbnB","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"aMzs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gatherActiveObservationsAtDepth", ()=>gatherActiveObservationsAtDepth);
var _resizeObservers = require("../utils/resizeObservers");
var _calculateDepthForNode = require("./calculateDepthForNode");
var gatherActiveObservationsAtDepth = function(depth) {
    (0, _resizeObservers.resizeObservers).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, _calculateDepthForNode.calculateDepthForNode)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};

},{"../utils/resizeObservers":"eJHXM","./calculateDepthForNode":"aZZX7","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"hWT5z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueResizeObserver", ()=>queueResizeObserver);
var _queueMicroTask = require("./queueMicroTask");
var queueResizeObserver = function(cb) {
    (0, _queueMicroTask.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

},{"./queueMicroTask":"e1IdX","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"e1IdX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueMicroTask", ()=>queueMicroTask);
var trigger;
var callbacks = [];
var notify = function() {
    return callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var queueMicroTask = function(callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return notify();
        }).observe(el_1, config);
        trigger = function() {
            el_1.textContent = "" + (toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    callbacks.push(callback);
    trigger();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"Akdxw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObservation", ()=>ResizeObservation);
var _resizeObserverBoxOptions = require("./ResizeObserverBoxOptions");
var _calculateBoxSize = require("./algorithms/calculateBoxSize");
var _element = require("./utils/element");
var skipNotifyOnElement = function(target) {
    return !(0, _element.isSVG)(target) && !(0, _element.isReplacedElement)(target) && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, _calculateBoxSize.calculateBoxSize)(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();

},{"./ResizeObserverBoxOptions":"3ccM9","./algorithms/calculateBoxSize":"2QAoC","./utils/element":"2gbnB","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"3FGcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverDetail", ()=>ResizeObserverDetail);
var ResizeObserverDetail = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"45K1w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
// This could've been more streamlined with internal state instead of abusing
// refs to such extent, but then composing hooks and components could not opt out of unnecessary renders.
function useResolvedElement(subscriber, refOrElement) {
    var lastReportRef = (0, _react.useRef)(null);
    var refOrElementRef = (0, _react.useRef)(null);
    refOrElementRef.current = refOrElement;
    var cbElementRef = (0, _react.useRef)(null); // Calling re-evaluation after each render without using a dep array,
    // as the ref object's current value could've changed since the last render.
    (0, _react.useEffect)(function() {
        evaluateSubscription();
    });
    var evaluateSubscription = (0, _react.useCallback)(function() {
        var cbElement = cbElementRef.current;
        var refOrElement = refOrElementRef.current; // Ugly ternary. But smaller than an if-else block.
        var element = cbElement ? cbElement : refOrElement ? refOrElement instanceof Element ? refOrElement : refOrElement.current : null;
        if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) return;
        if (lastReportRef.current && lastReportRef.current.cleanup) lastReportRef.current.cleanup();
        lastReportRef.current = {
            element: element,
            subscriber: subscriber,
            // Only calling the subscriber, if there's an actual element to report.
            // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
            cleanup: element ? subscriber(element) : undefined
        };
    }, [
        subscriber
    ]); // making sure we call the cleanup function on unmount
    (0, _react.useEffect)(function() {
        return function() {
            if (lastReportRef.current && lastReportRef.current.cleanup) {
                lastReportRef.current.cleanup();
                lastReportRef.current = null;
            }
        };
    }, []);
    return (0, _react.useCallback)(function(element) {
        cbElementRef.current = element;
        evaluateSubscription();
    }, [
        evaluateSubscription
    ]);
}
// We're only using the first element of the size sequences, until future versions of the spec solidify on how
// exactly it'll be used for fragments in multi-column scenarios:
// From the spec:
// > The box size properties are exposed as FrozenArray in order to support elements that have multiple fragments,
// > which occur in multi-column scenarios. However the current definitions of content rect and border box do not
// > mention how those boxes are affected by multi-column layout. In this spec, there will only be a single
// > ResizeObserverSize returned in the FrozenArray, which will correspond to the dimensions of the first column.
// > A future version of this spec will extend the returned FrozenArray to contain the per-fragment size information.
// (https://drafts.csswg.org/resize-observer/#resize-observer-entry-interface)
//
// Also, testing these new box options revealed that in both Chrome and FF everything is returned in the callback,
// regardless of the "box" option.
// The spec states the following on this:
// > This does not have any impact on which box dimensions are returned to the defined callback when the event
// > is fired, it solely defines which box the author wishes to observe layout changes on.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// I'm not exactly clear on what this means, especially when you consider a later section stating the following:
// > This section is non-normative. An author may desire to observe more than one CSS box.
// > In this case, author will need to use multiple ResizeObservers.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// Which is clearly not how current browser implementations behave, and seems to contradict the previous quote.
// For this reason I decided to only return the requested size,
// even though it seems we have access to results for all box types.
// This also means that we get to keep the current api, being able to return a simple { width, height } pair,
// regardless of box option.
function extractSize(entry, boxProp, sizeType) {
    if (!entry[boxProp]) {
        if (boxProp === "contentBoxSize") // The dimensions in `contentBoxSize` and `contentRect` are equivalent according to the spec.
        // See the 6th step in the description for the RO algorithm:
        // https://drafts.csswg.org/resize-observer/#create-and-populate-resizeobserverentry-h
        // > Set this.contentRect to logical this.contentBoxSize given target and observedBox of "content-box".
        // In real browser implementations of course these objects differ, but the width/height values should be equivalent.
        return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return undefined;
    } // A couple bytes smaller than calling Array.isArray() and just as effective here.
    return entry[boxProp][0] ? entry[boxProp][0][sizeType] : // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    entry[boxProp][sizeType];
}
function useResizeObserver(opts) {
    if (opts === void 0) opts = {};
    // Saving the callback as a ref. With this, I don't need to put onResize in the
    // effect dep array, and just passing in an anonymous function without memoising
    // will not reinstantiate the hook's ResizeObserver.
    var onResize = opts.onResize;
    var onResizeRef = (0, _react.useRef)(undefined);
    onResizeRef.current = onResize;
    var round = opts.round || Math.round; // Using a single instance throughout the hook's lifetime
    var resizeObserverRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)({
        width: undefined,
        height: undefined
    }), size = _useState[0], setSize = _useState[1]; // In certain edge cases the RO might want to report a size change just after
    // the component unmounted.
    var didUnmount = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        didUnmount.current = false;
        return function() {
            didUnmount.current = true;
        };
    }, []); // Using a ref to track the previous width / height to avoid unnecessary renders.
    var previous = (0, _react.useRef)({
        width: undefined,
        height: undefined
    }); // This block is kinda like a useEffect, only it's called whenever a new
    // element could be resolved based on the ref option. It also has a cleanup
    // function.
    var refCallback = useResolvedElement((0, _react.useCallback)(function(element) {
        // We only use a single Resize Observer instance, and we're instantiating it on demand, only once there's something to observe.
        // This instance is also recreated when the `box` option changes, so that a new observation is fired if there was a previously observed element with a different box option.
        if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) resizeObserverRef.current = {
            box: opts.box,
            round: round,
            instance: new ResizeObserver(function(entries) {
                var entry = entries[0];
                var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
                var reportedWidth = extractSize(entry, boxProp, "inlineSize");
                var reportedHeight = extractSize(entry, boxProp, "blockSize");
                var newWidth = reportedWidth ? round(reportedWidth) : undefined;
                var newHeight = reportedHeight ? round(reportedHeight) : undefined;
                if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
                    var newSize = {
                        width: newWidth,
                        height: newHeight
                    };
                    previous.current.width = newWidth;
                    previous.current.height = newHeight;
                    if (onResizeRef.current) onResizeRef.current(newSize);
                    else if (!didUnmount.current) setSize(newSize);
                }
            })
        };
        resizeObserverRef.current.instance.observe(element, {
            box: opts.box
        });
        return function() {
            if (resizeObserverRef.current) resizeObserverRef.current.instance.unobserve(element);
        };
    }, [
        opts.box,
        round
    ]), opts.ref);
    return (0, _react.useMemo)(function() {
        return {
            ref: refCallback,
            width: size.width,
            height: size.height
        };
    }, [
        refCallback,
        size.width,
        size.height
    ]);
}

},{"react":"4YI3l","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"cMevO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StopsList);
var _preact = require("preact");
var _hooks = require("preact/hooks");
function rowSpaner(stopGrid, column, stop) {
    if (!stop) return 1;
    let span = 1;
    let rowIndex = stopGrid.findIndex((pair)=>pair[column] === stop);
    while(stopGrid[++rowIndex] && !stopGrid[rowIndex][column]){
        // Indicate the column has been rowspan-ed
        stopGrid[rowIndex][column] = '___';
        span++;
    }
    return span;
}
function isOpposite(stop) {
    return /[19]$/.test(stop);
}
function getOpposite(stop) {
    if (isOpposite(stop)) return stop.replace(/[19]$/, (d)=>d === '1' ? 9 : 1);
    return null;
}
function areOpposite(stop1, stop2) {
    if (!stop1 || !stop2) return false;
    return stop1 !== stop2 && stop1 === getOpposite(stop2);
}
function StopsList(props) {
    const { routes, stopsData, onStopClick, onStopClickAgain } = props;
    if (!routes || !routes.length || routes[0].length <= 1 || routes[1] && routes[1].length <= 1 || !stopsData) return null;
    const [route1, route2] = routes;
    if (route1 && route2) {
        route1[0], route2[0];
        route1[route1.length - 1], route2[route2.length - 1];
        route1[route1.length - 1] === route2[0] && (route2[route2.length - 1], route1[0]);
    }
    const route1Len = route1.length;
    const route1FirstStop = route1[0];
    const route1LastStop = route1[route1Len - 1];
    const lastStop = (0, _hooks.useRef)();
    const StopLink = ({ stop })=>stop ? (0, _preact.h)("a", {
            href: `#/stops/${stop}`,
            "data-stop": stop,
            onClick: (e)=>{
                e.preventDefault();
                if (lastStop.current === stop && onStopClickAgain) onStopClickAgain(stop);
                else if (onStopClick) onStopClick(stop);
                lastStop.current = stop;
            }
        }, (0, _preact.h)("b", {
            class: "mini-stop-tag"
        }, stop), (0, _preact.h)("br", null), stopsData[stop].name) : null;
    // Only 1 route & not a loop
    if (!route2 && route1FirstStop !== route1LastStop) {
        // Contains duplicates
        route1.some((val, i)=>route1.indexOf(val) !== i);
        return (0, _preact.h)("ol", {
            class: "stops-list"
        }, route1.map((s)=>(0, _preact.h)("li", null, (0, _preact.h)(StopLink, {
                stop: s
            }))));
    } else {
        // Complex table layout for complex routes yo
        const stopGrid = [];
        // Create mutable copies
        let route1Copy, route2Copy;
        let loopRoute = false; // A->A
        if (route2) {
            route1Copy = route1.slice();
            route2Copy = route2.slice().reverse(); // Reverse for easier index reference
        } else {
            // Mostly likely a loop route A⟲B
            // So, split route1 into two routes
            loopRoute = true;
            let half;
            let hasMidStop = false;
            const hasDupStops = [];
            for(let i = 1, j = route1Len - 2; route1Len > 3 && !half; i++, j--){
                const stop = route1[i];
                // console.log(i, j, route1, 1, stop);
                if (isOpposite(stop)) {
                    // WEIRD CASE: the route has duplicate stops!
                    // Don't check first item because last item is its duplicate in loop route
                    if (i !== route1.lastIndexOf(stop)) // TODO: Handle this usecase?
                    // Do nothing for now
                    hasDupStops.push(stop);
                    else {
                        // Normal case, let's find the middle index
                        const opStop = getOpposite(route1[i]);
                        const index = route1.lastIndexOf(opStop);
                        if (index > 0) j = index;
                    }
                }
                if (i === j - 1) half = j;
                else if (i === j) {
                    half = j;
                    hasMidStop = true;
                }
            }
            hasDupStops.length;
            route1Copy = route1.slice(0, half);
            route2Copy = route1.slice(-(route1Len - half - (hasMidStop ? 1 : 0))).reverse();
            // console.log('x', half, route1, route1Copy, route2Copy);
            /*
      const half = Math.floor(route1Len / 2);
      route1Copy = route1.slice(0, half);
      route2Copy = route1.slice(-half).reverse();
      */ if (hasMidStop) {
                // Odd
                const midStop = route1[half];
                if (areOpposite(midStop, route1[half - 1])) {
                    // ~~~ = Dummy stop to connect at the end
                    route2Copy.push(midStop, '~~~');
                    route1Copy.push('~~~');
                } else if (areOpposite(midStop, route1[half + 1])) {
                    route1Copy.push(midStop, '~~~');
                    route2Copy.push('~~~');
                } else {
                    // Throw in both because it'll be merged and rendered as a single stop later
                    route1Copy.push(midStop);
                    route2Copy.push(midStop);
                }
            } else {
                // Even
                route1Copy.push('~~~');
                route2Copy.push('~~~');
            }
        }
        // const oppositeStops = [];
        // route1Copy.forEach((s, i) => {
        //   const opS = getOpposite(s);
        //   if (opS) {
        //     if (
        //       route2Copy.includes(opS) &&
        //       !route1Copy.includes(opS) &&
        //       !route2Copy.includes(s)
        //     ) {
        //       oppositeStops.push(s, opS);
        //     }
        //   }
        // });
        let i = 0;
        const maxLoopCount = route1Copy.length + route2Copy.length;
        let col1IsEmpty = true, col2IsEmpty = true;
        let col1FirstStop = false, col2FirstStop = false, col1LastStop = false, col2LastStop = false;
        do {
            const stop1HasOpposite = route2Copy.includes(getOpposite(route1Copy[0]));
            const stop2HasOpposite = route1Copy.includes(getOpposite(route2Copy[0]));
            const stop1IsLast = route1Copy.length === 1 || !route1Copy.length;
            const stop2IsLast = route2Copy.length === 1 || !route2Copy.length;
            if (loopRoute && i === 0) stopGrid[i] = [
                route1Copy.shift(),
                route2Copy.shift()
            ];
            else if (stop1HasOpposite && !stop2HasOpposite || stop1IsLast && !stop1HasOpposite && !stop2IsLast && !stop2HasOpposite) stopGrid[i] = [
                null,
                route2Copy.shift()
            ];
            else if (!stop1HasOpposite && stop2HasOpposite || stop2IsLast && !stop2HasOpposite && !stop1IsLast && !stop1HasOpposite) stopGrid[i] = [
                route1Copy.shift(),
                null
            ];
            else stopGrid[i] = [
                route1Copy.shift(),
                route2Copy.shift()
            ];
            // Check empty columns
            if (stopGrid[i]?.[0] && col1IsEmpty) col1IsEmpty = false;
            else if (!stopGrid[i]?.[0] && !route1Copy.length) col1IsEmpty = true;
            if (stopGrid[i]?.[1] && col2IsEmpty) col2IsEmpty = false;
            else if (!stopGrid[i]?.[1] && !route2Copy.length) col2IsEmpty = true;
            // Extra metadata
            const metadata = {
                isSame: stopGrid[i][0] === stopGrid[i][1],
                // Same stop (very lazy check, no snapping)
                isOpposite: areOpposite(stopGrid[i][0], stopGrid[i][1]),
                col1IsEmpty,
                col2IsEmpty
            };
            // Check first/last stops
            if (stopGrid[i]?.[0] && !col1FirstStop) metadata.col1FirstStop = col1FirstStop = true;
            if (stopGrid[i]?.[1] && !col2FirstStop) metadata.col2FirstStop = col2FirstStop = true;
            if (!route1Copy.length && !col1LastStop) metadata.col1LastStop = col1LastStop = true;
            if (!route2Copy.length && !col2LastStop) metadata.col2LastStop = col2LastStop = true;
            // Final metadata push
            stopGrid[i]?.push(metadata);
            // Infinite loop guard
            if (i > maxLoopCount + 2) return null;
            i++;
        }while (route1Copy[0] || route2Copy[0]);
        // Postfix for loop routes (A->A)
        if (loopRoute) {
            const lastRow = stopGrid[stopGrid.length - 1];
            const last2ndRow = stopGrid[stopGrid.length - 2];
            if (lastRow[0] === lastRow[1] && last2ndRow?.includes(null)) {
                const [s1, s2, meta] = last2ndRow;
                if (lastRow[0] === '~~~') {
                    const theStop = /\d/.test(s1) ? s1 : s2;
                    stopGrid[stopGrid.length - 2] = [
                        theStop,
                        theStop,
                        {
                            ...meta,
                            col1LastStop: true,
                            col2LastStop: true
                        }
                    ];
                    stopGrid.pop();
                } else if (lastRow[0]) {
                    if (!s1) last2ndRow[0] = lastRow[0];
                    if (!s2) last2ndRow[1] = lastRow[0];
                    if (!s1 || !s2) stopGrid[stopGrid.length - 1] = [
                        '~~~',
                        '~~~',
                        {
                            col1LastStop: true,
                            col2LastStop: true
                        }
                    ];
                }
            }
        }
        const stopGridStops = stopGrid.flat().filter((v)=>/\d/.test(v)).filter((value, index, array)=>array.indexOf(value) == index);
        const routeStops = [
            ...route1,
            ...route2 || []
        ].filter((value, index, array)=>array.indexOf(value) == index);
        stopGridStops.length, routeStops.length;
        return (0, _preact.h)("table", {
            class: "stops-table"
        }, (0, _preact.h)("colgroup", null, (0, _preact.h)("col", {
            class: "stop"
        }), (0, _preact.h)("col", {
            class: "middle"
        }), (0, _preact.h)("col", {
            class: "stop"
        })), stopGrid.map(([s1, s2, { isSame, isOpposite, col1IsEmpty, col2IsEmpty, col1FirstStop, col2FirstStop, col1LastStop, col2LastStop }], index)=>{
            const isEdgeRows = (index === 0 || index === stopGrid.length - 1) && s1 === s2;
            return (0, _preact.h)((0, _preact.Fragment), null, index === 0 && (0, _preact.h)("tr", null, (0, _preact.h)("td", {
                colspan: "3"
            })), (0, _preact.h)("tr", {
                class: isEdgeRows ? 'edge' : ''
            }, isEdgeRows ? (0, _preact.h)("td", {
                class: `stop-${s1 === '~~~' ? 'u' : index === 0 ? 'start' : 'end'} ${loopRoute ? 'loop' : ''}`,
                colspan: "3"
            }, s1 !== '~~~' && (0, _preact.h)(StopLink, {
                stop: s1
            })) : (0, _preact.h)((0, _preact.Fragment), null, s1 ? s1 !== '___' && (0, _preact.h)("td", {
                class: `${col1IsEmpty ? '' : 'stop'} ${col1FirstStop ? 'first' : ''} ${col1LastStop ? 'last' : ''}`,
                rowspan: isOpposite || index === stopGrid.length - 1 || index === 0 ? 1 : rowSpaner(stopGrid, 0, s1)
            }, (0, _preact.h)(StopLink, {
                stop: s1
            })) : (0, _preact.h)("td", {
                class: col1IsEmpty ? '' : 'empty'
            }), (0, _preact.h)("td", {
                class: isOpposite ? 'opposite' : isSame ? 'same' : ''
            }), s2 ? s2 !== '___' && (0, _preact.h)("td", {
                class: `${col2IsEmpty ? '' : 'stop'} ${col2FirstStop ? 'first' : ''} ${col2LastStop ? 'last' : ''}`,
                rowspan: isOpposite || index === stopGrid.length - 1 || index === 0 ? 1 : rowSpaner(stopGrid, 1, s2)
            }, (0, _preact.h)(StopLink, {
                stop: s2
            })) : (0, _preact.h)("td", {
                class: col2IsEmpty ? '' : 'empty'
            }))));
        }));
    }
    return null;
}

},{"preact":"fvkQC","preact/hooks":"2EbRR","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7zRGY":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1mZqJ");

},{}],"kWviM":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("eVywM");

},{}],"7hVEL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aR9Wp");

},{}],"fNIWy":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("iFswf");

},{}],"lcYP5":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kJ0PH");

},{}],"ki0rJ":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("asY4P");

},{}],"e5BIP":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("bEn0N");

},{}],"hdUY8":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kOgQG");

},{}],"gumpS":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3cARN");

},{}]},["b94kx","iC1JR"], "iC1JR", "parcelRequireda9d", {}, "./", "/")

//# sourceMappingURL=repo.b091c6d1.js.map
